import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import ExcelJS from "exceljs";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

function ListadoArticulos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  // const URL_ARTICULOS_PROPORCION = process.env.REACT_APP_URL_ARTICULOS_PROPORCION;
  // const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  // const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_SUB_LINEAS = process.env.REACT_APP_URL_SUB_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  // const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  // const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;
  // const URL_COMPOSICIONES = process.env.REACT_APP_URL_COMPOSICIONES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;


  const [activo, setActivo] = useState("Si");
  // D3: modal con el desglose del costeo del artículo
  const [modalDesglose, setModalDesglose] = useState(false);
  const [desgloseRows, setDesgloseRows] = useState([]);
  const [desgloseArticulo, setDesgloseArticulo] = useState("");
  const [desgloseCostoActual, setDesgloseCostoActual] = useState(0);
  const [desgloseLoading, setDesgloseLoading] = useState(false);
  const [codigo, setCodigo] = useState("");
  const [codigoProveedor, setCodigoProveedor] = useState("");
  const [nombre, setNombre] = useState("");
  const [piezasPorCaja, setPiezasPorCaja] = useState("");
  const [cajasPorTarima, setCajasPorTarima] = useState(0);
  const [pesoCaja, setPesoCaja] = useState(0);
  const [pesoPieza, setPesoPieza] = useState(0);
  const [precioKilo, setPrecioKilo] = useState(0);
  const [precioTienda, setPrecioTienda] = useState(0);
  const [tamanoCaja, setTamanoCaja] = useState("");
  const [costoUSD, setCostoUSD] = useState("");
  const [costoMX, setCostoMX] = useState("");
  const [venta, setVenta] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
    const [codigoSAT, setCodigoSAT] = useState("NA");
    const [codigoUnidad, setCodigoUnidad] = useState("NA");
  const [lineas, setLineas] = useState([]);
  const [subLineas, setSubLineas] = useState([]);
  const [selectedSubLineaEdit, setSelectedSubLineaEdit] = useState("");
  const [marcas, setMarcas] = useState([]);
  // const [familias, setFamilias] = useState([]);
  // const [colecciones, setColecciones] = useState([]);
  // const [composiciones, setComposiciones] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [ano, setAno] = useState("");
  const [EAN, setEAN] = useState("");
  const [SKU, setSKU] = useState("");
  const [vendedores, setVendedores] = useState("");
  const [visibleInventario, setVisibleInventario] = useState("");
  const [selectedCodigo, setSelectedCodigo] = useState(0);
  const [selectedNombre, setSelectedNombre] = useState(0);
  const [selectedLinea, setSelectedLinea] = useState(0);
  const [selectedSubLinea, setSelectedSubLinea] = useState(0);
  const [selectedMarca, setSelectedMarca] = useState(0);
  const [selectedFamilia, setSelectedFamilia] = useState(0);
  // const [selectedColeccion, setSelectedColeccion] = useState(0);
  // const [selectedComposicion, setSelectedComposicion] = useState(0);
  const [selectedProveedor, setSelectedProveedor] = useState(0);
  const [selectedAno, setSelectedAno] = useState(0);
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
    const [lista1, setLista1] = useState(0);
  const [lista2, setLista2] = useState(0);
  const [lista3, setLista3] = useState(0);
  const [lista4, setLista4] = useState(0);
  const [lista5, setLista5] = useState(0);
  const [listaContenedor, setListaContenedor] = useState(0);
  const [cbm, setCbm] = useState(0);
  const [aranceles, setAranceles] = useState("");

  const [selectedLineaEdit, setSelectedLineaEdit] = useState("");
  const [selectedMarcaEdit, setSelectedMarcaEdit] = useState("");
  // const [selectedFamiliaEdit, setSelectedFamiliaEdit] = useState("");
  // const [selectedColeccionEdit, setSelectedColeccionEdit] = useState("");
  // const [selectedComposicionEdit, setSelectedComposicionEdit] = useState("");
  const [selectedProveedorEdit, setSelectedProveedorEdit] = useState("");
  const [selectedEmpresaEdit, setSelectedEmpresaEdit] = useState("");
  const [articuloRelacionadoEdit, setArticuloRelacionadoEdit] = useState("");
  const [idEditArticulo, setIdEditArticulo] = useState("");

  const [validaBoton, setValidaBoton] = useState(true);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [modalCotizador, setModalCotizador] = useState(false);
  const toggleCotizador = () => setModalCotizador(!modalCotizador);
  const [modalImportPrecios, setModalImportPrecios] = useState(false);
  const toggleImportPrecios = () => setModalImportPrecios(!modalImportPrecios);
  const [tcPromedio, setTcPromedio] = useState(0);
  const [importPreciosResult, setImportPreciosResult] = useState({ ok: 0, noEncontrados: [] });
  const [cotizador, setCotizador] = useState({
    sku: "",
    piezasPorCaja: "",
    cbmCaja: "",
    precioFob: "",
    cbmContenedor: "",
    fleteMaritimo: "",
    impuestos: "",
    tipoCambio: "",
    venta: "",
    envio: "",
    comision: "",
  });
  const handleChangeCotizador = (e) => {
    const { name, value } = e.target;
    setCotizador((prev) => ({ ...prev, [name]: value }));
  };
  const numCot = (v) => {
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  };

  // B3: exportar TODA la colección Articulos a Excel (campos editables).
  // Sube el mismo archivo con subirBaseArticulos() y el sistema patchea por _id.
  const CAMPOS_BASE_EDITABLES = [
    "_id", "codigo", "codigoProveedor", "nombre", "descripcion",
    "piezasPorCaja", "cajasPorTarima", "pesoCaja", "pesoPieza", "cbm",
    "precioKilo", "precioTienda", "tamanoCaja",
    "costoUSD", "costoMX", "venta", "observaciones",
    "codigoSAT", "codigoUnidad", "ano", "EAN", "SKU",
    "activo", "foto", "visibleInventario",
    "lista1", "lista2", "lista3", "lista4", "lista5", "listaContenedor",
    "aranceles",
  ];
  // Campos del Excel que revelan lo que cuesta la mercancía
  const CAMPOS_COSTO_BASE = ["costoUSD", "costoMX", "precioKilo"];
  function descargarBaseArticulos() {
    if (!comments.length) {
      Swal.fire({ icon: "warning", title: "Sin datos", text: "No hay artículos que descargar" });
      return;
    }
    // Solo campos escalares; nombres de línea/marca/proveedor van como referencia (no se re-importan).
    const rows = comments.map((a) => {
      const r = {};
      for (const k of CAMPOS_BASE_EDITABLES) {
        // Sin permiso de costos, el Excel sale sin ellos. Al re-subirlo no pasa
        // nada: los campos ausentes no se actualizan.
        if (!user.verCostos && CAMPOS_COSTO_BASE.includes(k)) continue;
        r[k] = a[k] == null ? "" : a[k];
      }
      r.linea = a.linea || "";
      r.subLinea = a.subLinea || "";
      r.marca = a.marca || "";
      r.proveedor = a.proveedor || "";
      r.empresa = a.empresa || "";
      return r;
    });
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Articulos");
    const hoy = moment().format("YYYY-MM-DD");
    XLSX.writeFile(wb, `Articulos-BD-${hoy}.xlsx`);
  }
  async function subirBaseArticulos(event) {
    const target = event.target;
    if (target.name !== "fileBaseArticulos") return;
    if (!target.files || !target.files[0]) return;
    const confirm = await Swal.fire({
      title: "¿Actualizar la base?",
      text: "Se hará PATCH por _id sobre cada fila del Excel.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, actualizar",
    });
    if (!confirm.isConfirmed) { target.value = ""; return; }
    const reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);
    reader.onloadend = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const rows = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
      let ok = 0;
      const errores = [];
      // Log de columnas detectadas (para diagnóstico)
      if (rows.length > 0) {
        console.log("[SubirBD] Columnas en el Excel:", Object.keys(rows[0]));
        console.log("[SubirBD] Campos editables esperados:", CAMPOS_BASE_EDITABLES);
        const faltantes = CAMPOS_BASE_EDITABLES.filter(
          (k) => k !== "_id" && !(k in rows[0])
        );
        if (faltantes.length) {
          console.warn("[SubirBD] Campos AUSENTES en el Excel (no se actualizarán):", faltantes);
        }
      }
      // Mapa de traducción front→back para campos con nombre diferente en el modelo
      const RENAME_TO_MODEL = {
        activo: "is_active",
      };
      // Modal "Estamos trabajando" con contador de progreso
      let procesados = 0;
      const total = rows.length;
      Swal.fire({
        title: "Estamos trabajando...",
        html: `Actualizando base de artículos<br/><b id="swal-subirbd-line">0 / ${total} filas</b>`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading(),
      });
      const updateProgress = () => {
        const el = document.getElementById("swal-subirbd-line");
        if (el) el.textContent = `${procesados} / ${total} filas`;
      };
      for (const r of rows) {
        const id = String(r._id || "").trim();
        if (!id) { errores.push("fila sin _id"); procesados++; updateProgress(); continue; }
        const payload = {};
        for (const k of CAMPOS_BASE_EDITABLES) {
          if (k === "_id") continue;
          if (r[k] !== undefined && r[k] !== "") {
            const modelKey = RENAME_TO_MODEL[k] || k;
            payload[modelKey] = r[k];
          }
        }
        if (!Object.keys(payload).length) { procesados++; updateProgress(); continue; }
        try {
          await axios.patch(
            `${URL_ARTICULOS}/${id}`,
            payload,
            { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
          );
          console.log(`[SubirBD] ok ${r.codigo || id}`, payload);
          ok++;
        } catch (err) {
          const msg = err?.response?.data?.validation?.body?.message
            || err?.response?.data?.message
            || err?.message
            || "error";
          console.error(`[SubirBD] FAIL ${r.codigo || id}:`, msg, err?.response?.data, "payload:", payload);
          errores.push(`${r.codigo || id}: ${msg}`);
        }
        procesados++;
        updateProgress();
      }
      Swal.close();
      Swal.fire({
        icon: errores.length ? "warning" : "success",
        title: "Base actualizada",
        html: `${ok} artículos actualizados. ${errores.length} errores.` +
          (errores.length ? `<br/><br/><small style="text-align:left;display:block;">${errores.slice(0, 5).join("<br/>")}${errores.length > 5 ? `<br/>… y ${errores.length - 5} más` : ""}</small>` : ""),
      }).then(() => window.location.reload());
    };
    target.value = "";
  }

  // D3: desglose de cómo se calculó el costoMX de un artículo.
  async function abrirDesgloseCosto(a) {
    setDesgloseArticulo(`${a.codigo || ""} ${a.nombre || ""}`.trim());
    setDesgloseCostoActual(Number(a.costoMX) || 0);
    setDesgloseRows([]);
    setDesgloseLoading(true);
    setModalDesglose(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_ARTICULOS_EMBARQUES}/costeo/${a._id}`,
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      setDesgloseRows(res.data || []);
    } catch (err) {
      console.log("[desglose costo]", err);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo cargar el desglose" });
    } finally {
      setDesgloseLoading(false);
    }
  }

  // C21: duplicar artículo. Confirma y manda al alta con ?duplicar=<id>,
  // donde se precargan todos los datos menos el código (debe ser único).
  async function duplicarArticulo(id, codigo, nombre) {
    const conf = await Swal.fire({
      title: "Duplicar artículo",
      html: `Se abrirá el alta con los datos de <b>${codigo || ""} ${nombre || ""}</b> precargados.<br/>Solo tendrás que capturar el código nuevo y ajustar lo necesario.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, duplicar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#28a745",
    });
    if (!conf.isConfirmed) return;
    window.location.href = `/ArticulosCreate?duplicar=${id}`;
  }

  // V1: importar precios desde Excel y actualizar costoUSD/costoMX
  function importarPreciosExcel(event) {
    const target = event.target;
    if (target.name !== "filePrecios") return;
    const tc = parseFloat(tcPromedio) || 0;
    if (tc <= 0) {
      Swal.fire({ icon: "warning", title: "Captura TC", text: "Captura el TC promedio antes de subir el Excel" });
      target.value = "";
      return;
    }
    const reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);
    reader.onloadend = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const rows = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
      const articulosMap = {};
      comments.forEach((a) => {
        if (a.codigo) articulosMap[String(a.codigo).trim().toLowerCase()] = a;
      });
      const noEncontrados = [];
      let okCount = 0;
      const promises = [];
      // Helper: primer valor no-nulo/no-vacío entre varios headers posibles
      const pick = (r, keys) => {
        for (const k of keys) {
          const v = r?.[k];
          if (v !== undefined && v !== null && String(v).trim() !== "") return v;
        }
        return null;
      };
      for (const r of rows) {
        const code = String(pick(r, [
          "codigo", "Codigo", "CODIGO", "SKU", "sku",
          "N° PIEZA", "N° Pieza", "No Pieza", "N Pieza",
        ]) || "").trim().toLowerCase();
        if (!code) continue;
        const art = articulosMap[code];
        if (!art) { noEncontrados.push(code); continue; }
        const fobNuevo = parseFloat(pick(r, ["fob", "FOB", "costoUSD"]) || 0);
        // W19: aceptar columnas listaN para actualizar precios de venta también.
        // Acepta variantes de capitalización (lista1 / Lista1 / LISTA1).
        const parseLista = (n) => {
          const v = pick(r, [`lista${n}`, `Lista${n}`, `LISTA${n}`]);
          return v != null ? parseFloat(v) : null;
        };
        const lista1 = parseLista(1);
        const lista2 = parseLista(2);
        const lista3 = parseLista(3);
        const lista4 = parseLista(4);
        const lista5 = parseLista(5);
        // C13: listaContenedor acepta también el header "PRECIO" del Excel CBM y Peso
        const lcRaw = pick(r, [
          "listaContenedor", "Lista Contenedor", "LISTA CONTENEDOR",
          "PRECIO", "Precio", "precio",
        ]);
        const listaContenedor = lcRaw != null ? parseFloat(lcRaw) : null;
        const payload = {};
        if (fobNuevo > 0) {
          const fobPromedio = (parseFloat(art.costoUSD) + fobNuevo) / 2;
          payload.costoUSD = fobPromedio;
          payload.costoMX = fobPromedio * tc;
        }
        // Si viene lista1, calcular las demás automáticamente; si vienen explícitas, respetar
        if (lista1 != null && !isNaN(lista1) && lista1 > 0) {
          payload.lista1 = lista1;
          payload.lista2 = lista2 != null && !isNaN(lista2) ? lista2 : Number((lista1 * 0.7).toFixed(2));
          payload.lista3 = lista3 != null && !isNaN(lista3) ? lista3 : Number((lista1 * 0.75).toFixed(2));
          payload.lista4 = lista4 != null && !isNaN(lista4) ? lista4 : Number((lista1 * 0.8).toFixed(2));
          payload.lista5 = lista5 != null && !isNaN(lista5) ? lista5 : Number((lista1 * 0.85).toFixed(2));
        } else {
          if (lista2 != null && !isNaN(lista2)) payload.lista2 = lista2;
          if (lista3 != null && !isNaN(lista3)) payload.lista3 = lista3;
          if (lista4 != null && !isNaN(lista4)) payload.lista4 = lista4;
          if (lista5 != null && !isNaN(lista5)) payload.lista5 = lista5;
        }
        // listaContenedor: se acepta explícita (no se calcula automático)
        if (listaContenedor != null && !isNaN(listaContenedor)) {
          payload.listaContenedor = listaContenedor;
        }
        if (Object.keys(payload).length === 0) continue;
        // DEBUG: verifica que se detecte el header de Lista Contenedor
        console.log(`[SubirVentaExcel] ${code}`, {
          headersRow: Object.keys(r),
          lcRaw,
          listaContenedor,
          payload,
        });
        promises.push(
          axios.patch(
            `${URL_ARTICULOS}/${art._id}`,
            payload,
            { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
          ).then((resp) => {
            okCount++;
            console.log(`[SubirVentaExcel] ok ${code}`, resp?.data);
          })
            .catch((err) => {
              const msg = err?.response?.data?.validation?.body?.message
                || err?.response?.data?.message
                || err?.message
                || "error patch";
              console.error("[SubirVentaExcel] PATCH failed for", code, msg, err?.response?.data);
              noEncontrados.push(`${code} (${msg})`);
            })
        );
      }
      Promise.all(promises).then(() => {
        setImportPreciosResult({ ok: okCount, noEncontrados });
        Swal.fire({
          icon: "success",
          title: "Precios actualizados",
          text: `${okCount} artículos actualizados. ${noEncontrados.length} no encontrados.`,
        }).then(() => {
          window.location.reload();
        });
      });
    };
    target.value = "";
  }
  // Y1: importar precio Venta 30% (=Lista2) desde Excel y calcular las otras listas.
  //   Excel: columnas "codigo" + "venta" (el precio ya con 30% de descuento sobre Lista1).
  //   Lista1 = venta / 0.70   (base)
  //   Lista2 = venta           (-30%)
  //   Lista3 = Lista1 * 0.75   (-25%)
  //   Lista4 = Lista1 * 0.80   (-20%)
  //   Lista5 = Lista1 * 0.85   (-15%)
  function importarVentaExcel(event) {
    const target = event.target;
    if (target.name !== "fileVenta") return;
    if (!target.files || !target.files[0]) return;
    const reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);
    reader.onloadend = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const rows = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
      const articulosMap = {};
      comments.forEach((a) => {
        if (a.codigo) articulosMap[String(a.codigo).trim().toLowerCase()] = a;
      });
      const pick = (r, keys) => {
        for (const k of keys) {
          const v = r?.[k];
          if (v !== undefined && v !== null && String(v).trim() !== "") return v;
        }
        return null;
      };
      const noEncontrados = [];
      let okCount = 0;
      const promises = [];
      // Contador de progreso para el modal "Estamos trabajando"
      let procesados = 0;
      let totalPatches = 0;
      const updateProgress = () => {
        const el = document.getElementById("swal-progress-line");
        if (el) el.textContent = `${procesados} / ${totalPatches} artículos`;
      };
      for (const r of rows) {
        const code = String(pick(r, [
          "codigo", "Codigo", "CODIGO", "SKU", "sku",
          "N° PIEZA", "N° Pieza", "No Pieza", "N Pieza",
        ]) || "").trim().toLowerCase();
        if (!code) continue;
        const art = articulosMap[code];
        if (!art) { noEncontrados.push(code); continue; }
        // Lista1 (base). Puede venir vacía si sólo se quiere actualizar listaContenedor.
        const lista1Raw = pick(r, ["lista1", "Lista1", "LISTA1"]);
        const lista1Base = lista1Raw != null ? parseFloat(lista1Raw) : 0;
        // C13: Lista Contenedor (dato crudo, no se calcula nada sobre él)
        const lcRaw = pick(r, [
          "listaContenedor", "Lista Contenedor", "LISTA CONTENEDOR",
          "PRECIO", "Precio", "precio",
        ]);
        const listaContenedor = lcRaw != null ? parseFloat(lcRaw) : null;

        const payload = {};
        // Lista1 = base; Lista2 = -30%, Lista3 = -25%, Lista4 = -20%, Lista5 = -15%
        if (lista1Base > 0) {
          payload.lista1 = lista1Base;
          payload.lista2 = Number((lista1Base * 0.70).toFixed(2));
          payload.lista3 = Number((lista1Base * 0.75).toFixed(2));
          payload.lista4 = Number((lista1Base * 0.80).toFixed(2));
          payload.lista5 = Number((lista1Base * 0.85).toFixed(2));
          payload.venta = lista1Base;
        }
        // Lista Contenedor: se guarda tal cual (sin fórmula)
        if (listaContenedor != null && !isNaN(listaContenedor)) {
          payload.listaContenedor = listaContenedor;
        }
        if (Object.keys(payload).length === 0) continue;

        totalPatches++;
        console.log(`[SubirVentaExcel] ${code}`, {
          headersRow: Object.keys(r),
          lcRaw,
          listaContenedor,
          payload,
        });
        promises.push(
          axios.patch(
            `${URL_ARTICULOS}/${art._id}`,
            payload,
            { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
          ).then((resp) => {
            okCount++;
            procesados++;
            updateProgress();
            console.log(`[SubirVentaExcel] ok ${code}`, resp?.data);
          })
            .catch((err) => {
              procesados++;
              updateProgress();
              const msg = err?.response?.data?.validation?.body?.message
                || err?.response?.data?.message
                || err?.message
                || "error patch";
              console.error("[SubirVentaExcel] PATCH failed for", code, msg, err?.response?.data);
              noEncontrados.push(`${code} (${msg})`);
            })
        );
      }

      // Modal "Estamos trabajando..." con contador
      Swal.fire({
        title: "Estamos trabajando...",
        html: `Actualizando precios<br/><b id="swal-progress-line">0 / ${totalPatches} artículos</b>`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
          updateProgress();
        },
      });

      Promise.all(promises).then(() => {
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Precios actualizados",
          text: `${okCount} artículos actualizados. ${noEncontrados.length} no encontrados/omitidos.`,
        }).then(() => { window.location.reload(); });
      });
    };
    target.value = "";
  }

  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalProporcion, setModalProporcion] = useState(false);
  const toggleProporcion = () => setModalProporcion(!modalProporcion);
  const [proporcion, setProporcion] = useState([]);
  const [amounts, setAmounts] = useState([]);
  const [arrayColores, setArrayColores] = useState([]);
  const [arrayColoresNew, setArrayColoresNew] = useState([]);
  const [arrayTallasNew, setArrayTallasNew] = useState([]);


  const [modalDuplicar, setModalDuplicar] = useState(false);
  const toggleDuplicar = () => setModalDuplicar(!modalDuplicar);
  const [idDuplicar, setidDuplicar] = useState([])
  const [codigoDuplicar, setcodigoDuplicar] = useState("")
  const [nombreDuplicar, setnombreDuplicar] = useState("")
  const [descripcionDuplicar, setdescripcionDuplicar] = useState("")
  const [pesoCajaDuplicar, setpesoCajaDuplicar] = useState(0)
  const [precioTiendaDuplicar, setprecioTiendaDuplicar] = useState(0)
  const [tamanoCajaDuplicar, settamanoCajaDuplicar] = useState("")
  const [piezasPorCajaDuplicar, setpiezasPorCajaDuplicar] = useState(0)
  const [costoUSDDuplicar, setcostoUSDDuplicar] = useState(0)
  const [costoMXDuplicar, setcostoMXDuplicar] = useState(0)
  const [ventaDuplicar, setventaDuplicar] = useState(0)
  const [observacionesDuplicar, setobservacionesDuplicar] = useState("NA")
  const [codigoSATDuplicar, setcodigoSATDuplicar] = useState("NA")
  const [codigoUnidadDuplicar, setcodigoUnidadDuplicar] = useState("NA")
  const [lineasDuplicar, setlineasDuplicar] = useState("")
  const [marcasDuplicar, setmarcasDuplicar] = useState("")
  // const [familiasDuplicar, setfamiliasDuplicar] = useState("")
  // const [coleccionesDuplicar, setcoleccionesDuplicar] = useState("")
  // const [composicionesDuplicar, setcomposicionesDuplicar] = useState("")
  const [proveedoresDuplicar, setproveedoresDuplicar] = useState("")
  const [empresasDuplicar, setempresasDuplicar] = useState("")
  const [anoDuplicar, setanoDuplicar] = useState("")
  const [EANDuplicar, setEANDuplicar] = useState("")
  const [SKUDuplicar, setSKUDuplicar] = useState("")
  const [vendedoresDuplicar, setvendedoresDuplicar] = useState("")
  const [visibleInventarioDuplicar, setvisibleInventarioDuplicar] = useState("")
  // const [coloresDuplicar, setcoloresDuplicar] = useState("")
  // const [tallasDuplicar, settallasDuplicar] = useState("")
  const [foto, setFoto] = useState("")
  // const [proporcionDuplicar, setProporcionDuplicar] = useState([]);

  // const [arrayTallas, setArrayTallas] = useState([])
  // const [colores, setColores] = useState([])
  // const [tallas, setTallas] = useState([])
  // const [selectedColor, setSelectedColor] = useState("")
  // const [selectedTalla, setSelectedTalla] = useState("")

  const [inputFields, setInputFields] = useState([]);

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 1825);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(12), (val, index) => index + year);

  const [filesMasiva, setFilesMasiva] = useState([]);
  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;

  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);
  const [fotosArticulo, setFotosArticulo] = useState([]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  // Disponible por artículo (mismo dato que ListadoDisponible) y selección
  // por checkbox para el Excel de lista de precios.
  const [disponiblePorArticulo, setDisponiblePorArticulo] = useState({});
  const [seleccionados, setSeleccionados] = useState({});
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        // Array para pagination
        let arrayTabla = allArticulos
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              activo: a.is_active,
              codigo: a.codigo,
              codigoProveedor: a.codigoProveedor || a.codigo || "",
              nombre: a.nombre,
              piezasPorCaja: a.piezasPorCaja,
              cajasPorTarima: a.cajasPorTarima,
              pesoCaja: a.pesoCaja,
              pesoPieza: a.pesoPieza || 0,
              precioKilo: a.precioKilo || 0,
              fobEsperado: (a.precioKilo || 0) * (a.pesoPieza || 0),
              precioTienda: a.precioTienda,
              tamanoCaja: a.tamanoCaja,
              costoUSD: a.costoUSD,
              costoMX: a.costoMX,
              venta: a.venta,
              observaciones: a.observaciones,
              codigoSAT: a.codigoSAT,
              codigoUnidad: a.codigoUnidad,
              linea: a.lineas?.[0]?.name || "",
              subLinea: a.subLineas?.[0]?.name || "",
              idSubLinea: a.subLineas?.[0]?._id || "",
              marca: a.marcas?.[0]?.name || "",
              // familia: a.familias[0].name,
              // coleccion: a.colecciones[0].name,
              // composicion: a.composiciones[0].name,
              proveedor: a.proveedores?.[0]?.nombre_comercial || "",
              idLinea: a.lineas?.[0]?._id || "",
              idMarca: a.marcas?.[0]?._id || "",
              // idFamilia: a.familias[0]._id,
              // idColeccion: a.colecciones[0]._id,
              // idComposicion: a.composiciones[0]._id,
              idProveedor: a.proveedores?.[0]?._id || "",
              ano: a.ano,
              EAN: a.EAN,
              SKU: a.SKU,
              vendedores: a.vendedores,
              visibleInventario: a.visibleInventario,
              // colores: a.colores,
              // tallas: a.tallas,
              descripcion: a.descripcion,
              createdAt:a.createdAt,
              fecha: moment(a.createdAt).utcOffset('-0500').format("YYYY-MM-DD"),
              empresa: a.empresas?.[0]?.name || "",
              idEmpresa: a.empresas?.[0]?._id || "",
              foto: a.foto,
              fotos: Array.isArray(a.fotos) ? a.fotos : [],
              lista1: a.lista1,
              lista2: a.lista2,
              lista3: a.lista3,
              lista4: a.lista4,
              lista5: a.lista5 || 0,
              listaContenedor: a.listaContenedor || 0,
              cbm: a.cbm || 0,
              aranceles: a.aranceles,
              articuloRelacionado:
                a.articuloRelacionado && a.articuloRelacionado.length > 0
                  ? a.articuloRelacionado[0]._id
                  : "",
              articuloRelacionadoNombre:
                a.articuloRelacionado && a.articuloRelacionado.length > 0
                  ? `${a.articuloRelacionado[0].codigo} ${a.articuloRelacionado[0].nombre}`
                  : ""
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setComments(dataFinal);
        // Todos preseleccionados: la lista de precios sale completa por
        // default y el usuario va destildando lo que no quiera incluir.
        setSeleccionados(
          dataFinal.reduce((acc, a) => {
            acc[a._id] = true;
            return acc;
          }, {})
        );
        //
      })
      .catch((err) => {
        console.log(err);
        //
      });

      // Disponible por artículo: mismo endpoint que alimenta ListadoDisponible.
      //
      // Se usa `aLaMano`, NO `disponible`. El campo `disponible` de ese
      // endpoint suma además lo pendiente de recibir y lo pendiente de
      // embarcar, o sea mercancía que todavía no está en la bodega; por eso
      // BAL-010 salía en 2,799 cuando físicamente hay 799.
      // `aLaMano` = inventario visible − apartado en pedidos autorizados,
      // que es exactamente el Stock de DashboardVentasTabla.
      axios
      .get(`${URL_INVENTARIOS}Disponible`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const mapa = {};
        (res.data || []).forEach((d) => {
          const id = String(d.idArticulo || "");
          if (!id) return;
          mapa[id] = (mapa[id] || 0) + Number(d.aLaMano || 0);
        });
        setDisponiblePorArticulo(mapa);
      })
      .catch((err) => {
        console.log("[disponible]", err);
      });

      axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allEmpresas = res.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      })
    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allLineas = res.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_SUB_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => setSubLineas(res.data))
      .catch((err) => console.log(err));
    //   axios
    //   .get(URL_COLORES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allColores = res.data;
    //     setColores(allColores);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    //   axios
    //   .get(URL_TALLAS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allTallas = res.data;
    //     setTallas(allTallas);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allMarcas = res.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_FAMILIAS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allFamilias = res.data;
    //     setFamilias(allFamilias);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // axios
    //   .get(URL_COLECCIONES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allColecciones = res.data;
    //     setColecciones(allColecciones);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // axios
    //   .get(URL_COMPOSICIONES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allComposiciones = res.data;
    //     setComposiciones(allComposiciones);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    axios
    .get(`${URL_PROVEEDORES}Tipo/China`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);



  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedLinea == 0 || selectedLinea == a.idLinea) &&
        (selectedSubLinea == 0 || selectedSubLinea == a.idSubLinea) &&
        (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        // (selectedFamilia == 0 || selectedFamilia == a.idFamilia) &&
        // (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
        // (selectedComposicion == 0 || selectedComposicion == a.idComposicion) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
        // (selectedAno == 0 || selectedAno == a.ano) &&
        (activo == 0 || activo == a.activo)
      ) {
        return [
          a.codigo,
          a.nombre,
          a.piezasPorCaja,
          ...(user.verCostos
            ? [
                new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoUSD),
                new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoMX),
              ]
            : []),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.venta),
          a.linea,
          a.marca,
          // a.familia,
          // a.coleccion,
          // a.composicion,
          a.proveedor,
          // a.ano,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado Modelos`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Nombre",
          "Pzas x Caja",
          ...(user.verCostos ? ["FOB USD", "Costo MX"] : []),
          "Venta",
          "Linea",
          "Marca",
          // "Familia",
          // "Coleccion",
          // "Composicion",
          "Proveedor",
          // "Año",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
    });
    abrePDF(doc, `Modelos.pdf`);
  }

  // Pregunta común para PDF y Excel
  async function preguntarListaPrecios(textoBoton, opts = {}) {
    const inputOptions = {
      "1": "Lista 1 (base)",
      "2": "Lista 2 (−30%)",
      "3": "Lista 3 (−25%)",
      "4": "Lista 4 (−20%)",
      "5": "Lista 5 (−15%)",
    };
    // Opción extra para el Excel: usa Lista Contenedor + columnas Peso/CBM (sin proteger)
    if (opts.incluirCbmPeso) {
      inputOptions["cbm"] = "Lista Contenedor (CBM y Peso, sin proteger)";
    }
    const { value: lista } = await Swal.fire({
      title: "¿Qué lista de precios?",
      input: "select",
      inputOptions,
      inputPlaceholder: "Selecciona una opción",
      inputValidator: (v) => !v && "Selecciona una lista",
      showCancelButton: true,
      confirmButtonText: textoBoton || "Generar",
      cancelButtonText: "Cancelar",
    });
    if (!lista) return null;
    return lista === "cbm" ? "cbm" : Number(lista);
  }

  // Construye los grupos {linea: {subLinea: [articulos]}}
  //
  // La lista de precios lleva SIEMPRE todos los artículos: el checkbox no
  // decide quién sale, sino qué dice su columna DISPONIBILIDAD en el Excel
  // (ver el armado de la celda 6). Por eso aquí no se filtra por selección.
  function prepararGruposPrecios() {
    const articulos = comments
      .filter((a) =>
        (selectedLinea == 0 || selectedLinea == a.idLinea) &&
        (selectedSubLinea == 0 || selectedSubLinea == a.idSubLinea) &&
        (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
        (selectedAno == 0 || selectedAno == a.ano) &&
        (activo == 0 || activo == a.activo)
      )
      .sort((a, b) => {
        if (a.linea !== b.linea) return (a.linea || "").localeCompare(b.linea || "");
        if ((a.subLinea || "") !== (b.subLinea || "")) return (a.subLinea || "").localeCompare(b.subLinea || "");
        return (a.nombre || "").localeCompare(b.nombre || "");
      });
    const grupos = {};
    for (const a of articulos) {
      const ln = a.linea || "Sin Categoria";
      const sl = a.subLinea || "";
      grupos[ln] = grupos[ln] || {};
      grupos[ln][sl] = grupos[ln][sl] || [];
      grupos[ln][sl].push(a);
    }
    return grupos;
  }

  async function PDFListaPrecios() {
    const listaNum = await preguntarListaPrecios("Generar PDF");
    if (!listaNum) return;
    const campoLista = `lista${listaNum}`;
    const grupos = prepararGruposPrecios();
    const formato = (n) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(Number(n) || 0);
    const mesesEs = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];
    const hoy = new Date();
    const periodo = `${mesesEs[hoy.getMonth()]} ${hoy.getFullYear()}`;

    const doc = new jsPDF("portrait", "mm", "a4", true);
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 85, 10, 40, 22);
    doc.setFontSize(11);
    doc.text(`LISTA DE PRECIOS ${periodo} - LISTA ${listaNum}`, 105, 38, { align: "center" });

    // Una sola tabla con todo el contenido. Categoría y SubCategoría como filas
    // normales (sin rowSpan), así autoTable puede romper fila por fila y nunca
    // deja título/header huérfano cuando el bloque completo no cabe.
    const body = [];
    for (const linea of Object.keys(grupos).sort()) {
      body.push([{
        content: linea.toUpperCase(),
        colSpan: 5,
        styles: { fillColor: [255, 255, 255], textColor: 0, fontStyle: "bold", fontSize: 10, halign: "left", cellPadding: { top: 3, bottom: 1, left: 0, right: 0 }, lineWidth: 0 },
      }]);
      for (const subLinea of Object.keys(grupos[linea]).sort()) {
        const items = grupos[linea][subLinea];
        for (let i = 0; i < items.length; i++) {
          const a = items[i];
          body.push([
            {
              content: i === 0 ? (subLinea || "") : "",
              styles: { valign: "middle", halign: "center", fillColor: [245, 245, 245], fontStyle: "bold" },
            },
            a.codigo,
            a.nombre,
            `${a.piezasPorCaja || 1} pza`,
            formato(a[campoLista] || 0),
          ]);
        }
      }
    }

    doc.autoTable({
      head: [["SubCategoria", "N° Pieza", "Descripcion", "Piezas x Caja", "Costo + IVA"]],
      body,
      startY: 45,
      theme: "grid",
      headStyles: { fillColor: [200, 30, 30], textColor: 255, fontSize: 8, halign: "center" },
      bodyStyles: { fontSize: 7 },
      columnStyles: {
        0: { cellWidth: 22 },
        1: { cellWidth: 22 },
        2: { cellWidth: 95 },
        3: { cellWidth: 22, halign: "center" },
        4: { cellWidth: 25, halign: "right" },
      },
      margin: { left: 14, right: 14, top: 20 },
      showHead: "everyPage",
    });
    abrePDF(doc, `Lista-Precios-${listaNum}.pdf`);
  }

  async function ExcelListaPrecios() {
    const opcion = await preguntarListaPrecios("Generar Excel", { incluirCbmPeso: true });
    if (!opcion) return;
    const modoCbm = opcion === "cbm";
    const listaNum = modoCbm ? 1 : opcion; // sólo se usa para el label; en cbm el precio sale de listaContenedor
    const campoLista = modoCbm ? "listaContenedor" : `lista${listaNum}`;
    // Y1/W21: descuentos por lista respecto a Lista 1
    const listaDescuentos = { 1: "0%", 2: "-30%", 3: "-25%", 4: "-20%", 5: "-15%" };
    const listaLabel = modoCbm
      ? `Lista Contenedor (CBM y Peso)`
      : `Lista ${listaNum} (${listaDescuentos[listaNum] || ""})`;
    const grupos = prepararGruposPrecios();
    const mesesEs = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];
    const hoy = new Date();
    const periodo = `${mesesEs[hoy.getMonth()]} ${hoy.getFullYear()}`;

  // === EXCEL estilo "Lista de Precios" ===
  // Columnas: A=SubCategoria, B=N° Pieza, C=Descripcion, D=Piezas x Caja,
  //           E=Precio (sin IVA), F=Precio + IVA, G=Disponibilidad,
  //           H=Cantidad (editable), I=Subtotal OCULTA (H*E), J=Total (H*F)
  // El IVA ya no va en columna propia: vive en F como "Precio + IVA", que es
  // lo que se le muestra al cliente. Subtotal se conserva oculta por si se
  // necesita auditar el cálculo.
  const workbook = new ExcelJS.Workbook();
  const ws = workbook.addWorksheet(modoCbm ? `Lista 1 CBM Peso` : `Lista ${listaNum}`);
  const baseCols = [
    { width: 20 }, // A SubCategoria
    { width: 15 }, // B N° Pieza
    { width: 45 }, // C Descripcion
    { width: 12 }, // D Piezas x Caja
    { width: 12 }, // E Precio
    { width: 14 }, // F Precio + IVA
    { width: 16 }, // G Disponibilidad
    { width: 10 }, // H Cantidad
    { width: 14 }, // I Subtotal (oculta)
    { width: 14 }, // J Total
    { width: 10 }, // K Foto 1
    { width: 10 }, // L Foto 2
    { width: 10 }, // M Foto 3
    { width: 10 }, // N Foto 4
    { width: 10 }, // O Foto 5
  ];
  if (modoCbm) {
    baseCols.push({ width: 12 }); // P Peso Pieza (kg)
    baseCols.push({ width: 14 }); // Q Peso Total (kg) = G * P
    baseCols.push({ width: 12 }); // R CBM Pieza (m³)
    baseCols.push({ width: 14 }); // S CBM Total (m³) = G * R
  }
  ws.columns = baseCols;
  const totalCols = modoCbm ? 19 : 15; // hasta O (15) o S (19)
  const lastColLetter = modoCbm ? "S" : "O";

  const RED = "FFB02307";
  const GRAY = "FFF2F2F2";
  const GRAY_DARK = "FFDDDDDD";

  const border = {
    top: { style: "thin", color: { argb: "FF000000" } },
    left: { style: "thin", color: { argb: "FF000000" } },
    bottom: { style: "thin", color: { argb: "FF000000" } },
    right: { style: "thin", color: { argb: "FF000000" } },
  };

  // Logo (arriba, centrado entre A y G) — carga el PNG y lo ancla sobre el título.
  // Columnas suman ~144 units, centro ≈ 72. Logo grande ~200×100 (≈28 units ancho),
  // start ≈ 58 units → dentro de la columna C.
  try {
    const logoResp = await fetch(`${process.env.PUBLIC_URL || ""}/logoInstitucion.png`);
    if (logoResp.ok) {
      const logoBuf = await logoResp.arrayBuffer();
      const imgId = workbook.addImage({ buffer: logoBuf, extension: "png" });
      ws.addImage(imgId, {
        tl: { col: 3.5, row: 0 },
        ext: { width: 200, height: 100 },
        editAs: "oneCell",
      });
    }
  } catch (e) { /* si falla el logo, seguimos sin él */ }

  // Filas 1-4 reservadas SOLO para el logo (el png es 200x100, cabe en ~112px)
  ws.getRow(1).height = 28;
  ws.getRow(2).height = 28;
  ws.getRow(3).height = 28;
  ws.getRow(4).height = 28;

  // Fila 5: título mergeado (debajo del logo, sin encimarse)
  ws.mergeCells(`A5:${lastColLetter}5`);
  const titleCell = ws.getCell("A5");
  titleCell.value = `LISTA DE PRECIOS ${periodo} — ${listaLabel}`;
  titleCell.font = { bold: true, size: 16, color: { argb: RED } };
  titleCell.alignment = { vertical: "middle", horizontal: "center" };
  ws.getRow(5).height = 26;

  // Fila 6 spacer, fila 7 = headers (currentRow arranca en 8, no cambia)
  ws.getRow(6).height = 8;

  // Fila 7: headers de tabla (arrancan en col B, col A queda sin bordes)
  const headerRow = ws.getRow(7);
  const headers = ["", "N° PIEZA", "DESCRIPCION", "PIEZAS X CAJA", "PRECIO", "PRECIO + IVA", "DISPONIBILIDAD", "CANTIDAD", "SUBTOTAL", "TOTAL", "FOTO 1", "FOTO 2", "FOTO 3", "FOTO 4", "FOTO 5"];
  if (modoCbm) headers.push("PESO PIEZA (KG)", "PESO TOTAL (KG)", "CBM PIEZA (M³)", "CBM TOTAL (M³)");
  headers.forEach((h, i) => {
    const c = headerRow.getCell(i + 1);
    c.value = h;
    if (i === 0) return; // col A sin estilo (fuera de la cuadrícula)
    c.font = { bold: true, color: { argb: "FFFFFFFF" } };
    c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: RED } };
    c.alignment = { vertical: "middle", horizontal: "center" };
    c.border = border;
  });
  headerRow.height = 22;

  // Filas de datos agrupadas por Categoría > SubCategoría
  let currentRow = 8;
  const firstDataRow = currentRow;
  for (const linea of Object.keys(grupos).sort()) {
    // Fila de Categoría (bold, fondo gris claro, mergeada B:última — col A queda fuera)
    ws.mergeCells(`B${currentRow}:${lastColLetter}${currentRow}`);
    const catCell = ws.getCell(`B${currentRow}`);
    catCell.value = linea.toUpperCase();
    catCell.font = { bold: true, size: 11 };
    catCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: GRAY_DARK } };
    catCell.alignment = { vertical: "middle", horizontal: "left", indent: 1 };
    catCell.border = border;
    ws.getRow(currentRow).height = 20;
    currentRow++;

    let zebra = 0;
    for (const subLinea of Object.keys(grupos[linea]).sort()) {
      const items = grupos[linea][subLinea];
      if (!items.length) continue;
      const subStartRow = currentRow;
      // Filas de items
      for (const a of items) {
        const r = ws.getRow(currentRow);
        r.getCell(1).value = ""; // A: subcat, se rellena al mergear
        r.getCell(2).value = a.codigo;
        r.getCell(3).value = a.nombre;
        r.getCell(4).value = `${a.piezasPorCaja || 1} pza`;
        // Precio SIN IVA (los precios de lista no incluyen IVA)
        r.getCell(5).value = Number(a[campoLista] || 0);
        // Disponibilidad: manda ÚNICAMENTE la palomita del listado, no la
        // existencia. Así se puede ofrecer algo que está por llegar, o sacar
        // de la lista algo que hay en piso pero no se quiere vender.
        const hayDisponible = !!seleccionados[a._id];
        // F: precio con IVA, que es el que se le cotiza al cliente
        r.getCell(6).value = { formula: `E${currentRow}*1.16` };
        r.getCell(7).value = hayDisponible ? "Disponible" : "No disponible";
        r.getCell(8).value = ""; // H: cantidad, la única editable
        // Subtotal por línea = Cantidad × Precio
        // I: subtotal sin IVA (oculta), por si hay que auditar el cálculo
        r.getCell(9).value = { formula: `IF(OR(H${currentRow}="",H${currentRow}=0),0,H${currentRow}*E${currentRow})` };
        // IVA por línea = Subtotal × 0.16

        // Total por línea = Subtotal + IVA
        // J: total = cantidad × precio con IVA
        r.getCell(10).value = { formula: `IF(OR(H${currentRow}="",H${currentRow}=0),0,H${currentRow}*F${currentRow})` };
        // Fotos: hyperlink por columna (una por imagen, hasta 5) — cols J..N.
        const cloudBase = process.env.REACT_APP_URL_FOTO_CLOUDINARY;
        let urls = Array.isArray(a.fotos) ? a.fotos.filter(Boolean) : [];
        if (!urls.length && a.foto === "Si" && a._id && cloudBase) {
          urls = [`${cloudBase}/image/upload/macuroArticulos/${a._id}.jpg`];
        }
        for (let i = 0; i < 5; i++) {
          const cell = r.getCell(11 + i);
          const url = urls[i];
          if (url) {
            cell.value = { text: `Ver ${i + 1}`, hyperlink: url };
            cell.font = { color: { argb: "FF0563C1" }, underline: true };
          } else {
            cell.value = "";
          }
        }
        // Estilos
        r.getCell(5).numFmt = '"$"#,##0.00';
        r.getCell(6).numFmt = '"$"#,##0.00';
        // CANTIDAD son piezas, no dinero (salía con "$")
        r.getCell(8).numFmt = "#,##0";
        r.getCell(9).numFmt = '"$"#,##0.00';
        r.getCell(10).numFmt = '"$"#,##0.00';
        // Descripción con letra más chica + wrap, para que se vea el nombre completo
        r.getCell(3).font = { size: 8 };
        r.getCell(3).alignment = { vertical: "middle", horizontal: "left", wrapText: true };
        r.getCell(4).alignment = { horizontal: "center" };
        r.getCell(5).alignment = { horizontal: "right" };
        r.getCell(6).alignment = { horizontal: "right" };
        r.getCell(7).alignment = { horizontal: "center" };
        r.getCell(7).font = {
          bold: true,
          color: { argb: hayDisponible ? "FF1E7E34" : "FFC00000" },
        };
        r.getCell(7).alignment = { horizontal: "center" };
        r.getCell(8).alignment = { horizontal: "right" };
        r.getCell(9).alignment = { horizontal: "right" };
        r.getCell(10).alignment = { horizontal: "right" };
        for (let ci = 11; ci <= 15; ci++) r.getCell(ci).alignment = { horizontal: "center" };
        // Modo CBM y Peso:
        //   col O = Peso Pieza (kg) del artículo (dato estático)
        //   col P = Peso Total (kg) = Cantidad × Peso Pieza (fórmula)
        //   col Q = CBM Pieza (m³) del artículo (dato estático)
        //   col R = CBM Total (m³) = Cantidad × CBM Pieza (fórmula)
        if (modoCbm) {
          r.getCell(16).value = Number(a.pesoPieza || 0);
          r.getCell(16).numFmt = "0.000";
          r.getCell(16).alignment = { horizontal: "right" };
          r.getCell(17).value = { formula: `IF(OR(H${currentRow}="",H${currentRow}=0),0,H${currentRow}*P${currentRow})` };
          r.getCell(17).numFmt = "0.000";
          r.getCell(17).alignment = { horizontal: "right" };
          r.getCell(18).value = Number(a.cbm || 0);
          r.getCell(18).numFmt = "0.000";
          r.getCell(18).alignment = { horizontal: "right" };
          r.getCell(19).value = { formula: `IF(OR(H${currentRow}="",H${currentRow}=0),0,H${currentRow}*R${currentRow})` };
          r.getCell(19).numFmt = "0.000";
          r.getCell(19).alignment = { horizontal: "right" };
        }
        // Zebra (uno sí, uno no) + bordes de B a última; cols de foto (10..14) sin fondo zebra
        const zebraFill = zebra % 2 === 0 ? null : { type: "pattern", pattern: "solid", fgColor: { argb: GRAY } };
        for (let ci = 2; ci <= totalCols; ci++) {
          r.getCell(ci).border = border;
          if (zebraFill && ci < 11) r.getCell(ci).fill = zebraFill;
        }
        // Bloqueo: solo Cantidad (col 8) editable.
        // (La protección se aplica al final; sólo si !modoCbm.)
        for (let ci = 1; ci <= totalCols; ci++) {
          const editable = ci === 8;
          r.getCell(ci).protection = { locked: !editable };
        }
        zebra++;
        currentRow++;
      }
      // Merge de SubCategoría en col A (sin bordes — fuera de la cuadrícula)
      if (subLinea) {
        if (subStartRow < currentRow - 1) ws.mergeCells(`A${subStartRow}:A${currentRow - 1}`);
        const subCell = ws.getCell(`A${subStartRow}`);
        subCell.value = subLinea;
        subCell.font = { bold: true, size: 10 };
        subCell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      }
    }
  }
  const lastDataRow = currentRow - 1;

  /**
   * Escribe la fila de totales. Se usa DOS veces —al pie de la tabla y arriba,
   * junto al logo— desde una sola función para que sean idénticas: si se
   * escribieran por separado podrían quedar con distinto formato o, peor, con
   * sumas distintas.
   *
   * Las sumas siempre apuntan al rango de datos, así que las dos filas
   * muestran exactamente el mismo número.
   */
  const escribeFilaTotales = (fila) => {
    for (let ci = 2; ci <= 8; ci++) {
      ws.getCell(`${String.fromCharCode(64 + ci)}${fila}`).border = border;
    }
    const sub = ws.getCell(`I${fila}`);
    sub.value = { formula: `SUM(I${firstDataRow}:I${lastDataRow})` };
    sub.numFmt = '"$"#,##0.00';
    sub.font = { bold: true };
    sub.border = border;
    sub.fill = { type: "pattern", pattern: "solid", fgColor: { argb: GRAY } };

    const tot = ws.getCell(`J${fila}`);
    tot.value = { formula: `SUM(J${firstDataRow}:J${lastDataRow})` };
    tot.numFmt = '"$"#,##0.00';
    tot.font = { bold: true };
    tot.border = border;
    tot.fill = { type: "pattern", pattern: "solid", fgColor: { argb: GRAY } };

    // Cols K-O (fotos): sólo borde
    for (const col of ["K", "L", "M", "N", "O"]) {
      ws.getCell(`${col}${fila}`).border = border;
    }

    // Modo CBM y Peso:
    //   P (Peso Pieza) → sólo borde (dato unitario, no se suma)
    //   Q (Peso Total) → SUM = total kg del pedido
    //   R (CBM Pieza)  → sólo borde (dato unitario, no se suma)
    //   S (CBM Total)  → SUM = total m³ del pedido
    if (modoCbm) {
      for (const col of ["P", "R"]) {
        ws.getCell(`${col}${fila}`).border = border;
        ws.getCell(`${col}${fila}`).fill = { type: "pattern", pattern: "solid", fgColor: { argb: GRAY } };
      }
      for (const col of ["Q", "S"]) {
        const c = ws.getCell(`${col}${fila}`);
        c.value = { formula: `SUM(${col}${firstDataRow}:${col}${lastDataRow})` };
        c.numFmt = "0.000";
        c.font = { bold: true };
        c.border = border;
        c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: GRAY } };
        c.alignment = { horizontal: "right" };
      }
    }
  };

  const totalRow = currentRow;
  escribeFilaTotales(totalRow);
  // fotosCbmCols se sigue usando en addTotalRow para bordear filas de totales
  const fotosCbmCols = modoCbm
    ? ["K", "L", "M", "N", "O", "P", "Q", "R", "S"]
    : ["K", "L", "M", "N", "O"];
  currentRow++;

  /**
   * Un renglón "etiqueta | valor" del resumen (SUB TOTAL / IVA / TOTAL).
   * Se usa en el pie de la tabla y también arriba junto al logo, desde la
   * misma función para que los dos bloques salgan idénticos.
   */
  const escribeResumenFila = (fila, label, valueRef) => {
    // Label (G:I mergeado; I va oculta, así que el ancho visible lo dan G y H)
    ws.mergeCells(`G${fila}:I${fila}`);
    const lc = ws.getCell(`G${fila}`);
    lc.value = label;
    lc.font = { bold: true };
    lc.alignment = { horizontal: "right", vertical: "middle" };
    lc.fill = { type: "pattern", pattern: "solid", fgColor: { argb: GRAY } };
    lc.border = border;
    ws.getCell(`H${fila}`).border = border;
    ws.getCell(`I${fila}`).border = border;
    // Valor (J)
    const vc = ws.getCell(`J${fila}`);
    vc.value = { formula: valueRef };
    vc.numFmt = '"$"#,##0.00';
    vc.font = { bold: true };
    vc.alignment = { horizontal: "right" };
    vc.fill = { type: "pattern", pattern: "solid", fgColor: { argb: GRAY } };
    vc.border = border;
  };

  const addTotalRow = (label, valueRef, leyenda) => {
    // Leyenda a la izquierda (mergeada A:F)
    ws.mergeCells(`A${currentRow}:F${currentRow}`);
    const legendCell = ws.getCell(`A${currentRow}`);
    legendCell.value = leyenda || "";
    legendCell.font = { bold: true, size: 10 };
    legendCell.alignment = { horizontal: "left", vertical: "middle", indent: 1 };

    escribeResumenFila(currentRow, label, valueRef);

    // Cols K-última en filas de totales (solo borde)
    for (const col of fotosCbmCols) {
      ws.getCell(`${col}${currentRow}`).border = border;
    }
    currentRow++;
  };
  addTotalRow(
    "SUB TOTAL",
    `I${totalRow}`,
    "- LISTA DE PRECIOS Y DESCUENTOS SUJETA A CAMBIOS SIN PREVIO AVISO."
  );
  addTotalRow(
    // Ya no hay columna de IVA: es la diferencia entre el total (con IVA) y
    // el subtotal.
    "IVA",
    `J${totalRow}-I${totalRow}`,
    "- TODOS LOS PRECIOS SON MÁS IVA."
  );
  addTotalRow("TOTAL", `J${totalRow}`, "");
  currentRow++;

  // Pie de página con leyenda de la empresa
  ws.mergeCells(`A${currentRow}:${lastColLetter}${currentRow}`);
  const footerCell = ws.getCell(`A${currentRow}`);
  footerCell.value =
    "OFNOA PARTS S.A. DE C.V. – RFC: OPA241126VE9 – DIRECCIÓN: SAN FRANCISCO CUAUTLAPAN 68 DEP C A INDUSTRIAL NAUCALPAN, NAUCALPAN DE JUAREZ C.P. 53370";
  footerCell.font = { bold: true, size: 10, color: { argb: "FF000000" } };
  footerCell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
  footerCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: GRAY } };
  footerCell.border = border;
  ws.getRow(currentRow).height = 32;

  // Bloquear el header también
  headerRow.eachCell((c) => { c.protection = { locked: true }; });
  // Freeze pane después del header
  ws.views = [{ state: "frozen", ySplit: 7 }];
  // Print setup
  ws.pageSetup = { paperSize: 9, orientation: "portrait", fitToPage: true, fitToWidth: 1, fitToHeight: 0, margins: { left: 0.5, right: 0.5, top: 0.5, bottom: 0.5, header: 0.3, footer: 0.3 } };

  // Proteger hoja (solo Cantidad editable) — se omite en modo CBM y Peso
  if (!modoCbm) {
    await ws.protect(undefined, {
      selectLockedCells: true,
      selectUnlockedCells: true,
      formatCells: false,
      formatColumns: false,
      formatRows: false,
      insertColumns: false,
      insertRows: false,
      insertHyperlinks: false,
      deleteColumns: false,
      deleteRows: false,
      sort: false,
      autoFilter: false,
      pivotTables: false,
    });
  }

  // La columna de Subtotal se conserva para poder auditar, pero oculta: al
  // cliente sólo le interesan Precio, Precio + IVA y Total.
  ws.getColumn("I").hidden = true;

  // Los mismos totales, arriba a la derecha del logo (filas 1-4 son sólo del
  // logo, que arranca en la columna D). Va en la fila 3 para quedar a su
  // altura; la 5 no sirve porque está mergeada para el título.
  // El MISMO resumen, arriba a la derecha del logo. Las filas 1-4 están
  // reservadas para el logo, que arranca en la columna D; el bloque va de la
  // G en adelante, así que no lo tapa. La fila 5 no sirve: está mergeada
  // para el título.
  escribeResumenFila(2, "SUB TOTAL", `I${totalRow}`);
  escribeResumenFila(3, "IVA", `J${totalRow}-I${totalRow}`);
  escribeResumenFila(4, "TOTAL", `J${totalRow}`);

  const buf = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  // Nombre del archivo con el % de descuento de la lista (Lista 1 = base, sin sufijo)
  const listaPct = { 1: "", 2: "30", 3: "25", 4: "20", 5: "15" };
  const pct = listaPct[listaNum];
  link.download = pct
    ? `Lista-Precios-${pct}-${periodo}.xlsx`
    : `Lista-Precios-${periodo}.xlsx`;
  link.click();
  URL.revokeObjectURL(url);
}

  function excel() {
    const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
    const dataExcel = comments.map((a) => {
      if (
        (selectedLinea == 0 || selectedLinea == a.idLinea) &&
        (selectedSubLinea == 0 || selectedSubLinea == a.idSubLinea) &&
        (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
        (activo == 0 || activo == a.activo)
      ) {
        // B4: precio unitario (costo) + utilidad $ y % vs Lista1
        const precio = Number(a.lista1) || 0;
        const costo = Number(a.costoMX) || 0;
        const utilCant = round2(precio - costo);
        const utilPct = precio > 0 ? round2(((precio - costo) / precio) * 100) : 0;
        return {
          Codigo: a.codigo,
          Lista1: precio,
          ListaContenedor: round2(Number(a.listaContenedor) || 0),
          CostoUnitario: round2(costo),
          UtilidadCantidad: utilCant,
          UtilidadPorcentaje: utilPct,
        };
      }
    });
    const dataExcelLimpia = Object.values(dataExcel).filter((el) => el != null);

    const option = {
      fileName: "ListadoModelos",
      datas: [
        {
          sheetData: dataExcelLimpia,
          sheetName: "ListadoModelos",
          sheetFilter: [
            "Codigo",
            "Lista1",
            "ListaContenedor",
            "CostoUnitario",
            "UtilidadCantidad",
            "UtilidadPorcentaje",
          ],
          sheetHeader: [
            "Codigo",
            "Lista1",
            "Lista Contenedor",
            "Costo Unitario",
            "Utilidad $",
            "Utilidad %",
          ],
        },
      ],
    };

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedLinea == 0 || selectedLinea == a.idLinea) &&
        (selectedSubLinea == 0 || selectedSubLinea == a.idSubLinea) &&
        (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        // (selectedFamilia == 0 || selectedFamilia == a.idFamilia) &&
        // (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
        // (selectedComposicion == 0 || selectedComposicion == a.idComposicion) &&
        (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
        (selectedAno == 0 || selectedAno == a.ano) &&
        (activo == 0 || activo == a.activo)
      ) {
        return [
          a.codigo,
          a.nombre,
          a.piezasPorCaja,
          ...(user.verCostos
            ? [
                new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoUSD),
                new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoMX),
              ]
            : []),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.venta),
          a.linea,
          a.marca,
          // a.familia,
          // a.coleccion,
          // a.composicion,
          a.proveedor,
          a.ano,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado Modelos`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Nombre",
          "Pzas x Caja",
          ...(user.verCostos ? ["FOB USD", "Costo MX"] : []),
          "Venta",
          "Linea",
          "Marca",
          // "Familia",
          // "Coleccion",
          // "Composicion",
          "Proveedor",
          "Año",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Modelos",
          email: mailTo,
          fileName: "ListadoModelos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Modelos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  
  function jalaFoto(
    idEdit
  ) {
    setPhoto("")
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${idEdit}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.version) {
          setPhoto(data.data.version);
        }
      })
      .catch((err) => console.log(err));

    // Cargar array de fotos (máx 5) desde el mapping local.
    // Fallback para artículos con foto legacy (foto="Si", fotos=[]):
    // precargar slot 0 con la URL Cloudinary construida.
    const art = comments.find((c) => c._id === idEdit);
    let arr = Array.isArray(art?.fotos) ? [...art.fotos].filter(Boolean) : [];
    if (!arr.length && art?.foto === "Si") {
      const cloudBase = process.env.REACT_APP_URL_FOTO_CLOUDINARY;
      if (cloudBase) {
        arr = [`${cloudBase}/image/upload/macuroArticulos/${idEdit}.jpg`];
      }
    }
    setFotosArticulo(arr);

    setIdEditArticulo(idEdit);
    toggleFoto();
  }

  // B6: subir foto de artículo en slot 0..4. Actualiza fotos[] localmente.
  // Derivamos la URL base a partir de URL_FILEPOST (=REACT_APP_URL_UPPROFILE)
  // para no depender de env vars nuevas.
  function apiBase() {
    // URL_FILEPOST termina en /upprofile; reemplazamos por el endpoint deseado.
    return (URL_FILEPOST || "").replace(/\/upprofile\/?$/, "");
  }
  async function subirFotoSlot(slot, file) {
    if (!file || !idEditArticulo) return;
    const form = new FormData();
    form.append("file", file);
    form.append("articulo", idEditArticulo);
    form.append("slot", String(slot));
    try {
      await axios.post(
        `${apiBase()}/upFotoArticulo`,
        form,
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      // Cloudinary sirve la última versión; cache-bust en el src del <img>
      const cloudBase = process.env.REACT_APP_URL_FOTO_CLOUDINARY;
      const publicId = slot === 0
        ? `macuroArticulos/${idEditArticulo}`
        : `macuroArticulos/${idEditArticulo}_${slot}`;
      const url = `${cloudBase}/image/upload/${publicId}.jpg?t=${new Date().getTime()}`;
      setFotosArticulo((prev) => {
        const next = [...prev];
        next[slot] = url;
        return next;
      });
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error al subir", text: err?.response?.data || err.message });
    }
  }
  async function borrarFotoSlot(slot) {
    if (!idEditArticulo) return;
    try {
      await axios.delete(
        `${apiBase()}/delFotoArticulo/${idEditArticulo}/${slot}`,
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      setFotosArticulo((prev) => {
        const next = [...prev];
        next[slot] = "";
        return next;
      });
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error al borrar", text: err?.response?.data || err.message });
    }
  }


  function jalaInfo(
    codigo,
    nombre,
    piezasPorCaja,
    pesoCaja,
    pesoPieza,
    precioKilo,
    precioTienda,
    tamanoCaja,
    costoUSD,
    costoMX,
    venta,
    observaciones,
    codigoSAT,
    codigoUnidad,
    idLinea,
    idSubLinea,
    idMarca,
    // idFamilia,
    // idColeccion,
    // idComposicion,
    idProveedor,
    idEmpresa,
    ano,
    EAN,
    SKU,
    lista1,
    lista2,
    lista3,
    lista4,
    lista5,
    listaContenedor,
    cbm,
    aranceles,
    vendedores,
    visibleInventario,
    idEdit,
    articuloRelacionado,
    codigoProveedor,
    cajasPorTarima
  ) {
    setCodigo(codigo);
    setCodigoProveedor(codigoProveedor || "");
    setNombre(nombre);
    setPiezasPorCaja(piezasPorCaja);
    setCajasPorTarima(cajasPorTarima || 0);
    setPesoCaja(pesoCaja);
    setPesoPieza(pesoPieza || 0);
    setPrecioKilo(precioKilo || 0);
    setPrecioTienda(precioTienda);
    setTamanoCaja(tamanoCaja);
    setCostoUSD(costoUSD);
    setCostoMX(costoMX);
    setVenta(venta);
    setObservaciones(observaciones);
    setCodigoSAT(codigoSAT);
    setCodigoUnidad(codigoUnidad);
    setSelectedLineaEdit(idLinea);
    setSelectedSubLineaEdit(idSubLinea || "");
    setSelectedMarcaEdit(idMarca);
    // setSelectedFamiliaEdit(idFamilia);
    // setSelectedColeccionEdit(idColeccion);
    // setSelectedComposicionEdit(idComposicion);
    setSelectedProveedorEdit(idProveedor);
    setSelectedEmpresaEdit(idEmpresa);
    setAno(ano);
    setEAN(EAN);
    setSKU(SKU);
    setLista1(lista1);
    setLista2(lista2);
    setLista3(lista3);
    setLista4(lista4);
    setLista5(lista5 || 0);
    setListaContenedor(listaContenedor || 0);
    setCbm(cbm || 0);
    setAranceles(aranceles);
    setVendedores(vendedores);
    setVisibleInventario(visibleInventario);
    setIdEditArticulo(idEdit);
    setArticuloRelacionadoEdit(articuloRelacionado || "");
    toggleEdit();
  }

  function editArticulos(event) {
    event.preventDefault();
    const URL_ARTICULOS_EDIT = `${process.env.REACT_APP_URL_ARTICULOS}/${idEditArticulo}`;
    if (file == null) {

        axios.patch(
          URL_ARTICULOS_EDIT,
          {
            codigo,
            nombre,
            piezasPorCaja,
            cajasPorTarima: Number(cajasPorTarima) || 0,
            pesoCaja,
            pesoPieza,
            precioKilo,
            precioTienda,
            tamanoCaja,
            costoUSD,
            costoMX,
            venta,
            lineas: selectedLineaEdit,
            subLineas: selectedSubLineaEdit || undefined,
            marcas: selectedMarcaEdit,
            // familias: selectedFamiliaEdit,
            // colecciones: selectedColeccionEdit,
            // composiciones: selectedComposicionEdit,
            proveedores: selectedProveedorEdit,
            empresas: selectedEmpresaEdit,
            ano,
            EAN,
            SKU,
            lista1,
            lista2,
            lista3,
            lista4,
            lista5,
            listaContenedor,
            cbm,
            aranceles,
            vendedores,
            visibleInventario,
            codigoSAT,
            codigoUnidad,
            articuloRelacionado: articuloRelacionadoEdit
              ? [articuloRelacionadoEdit]
              : [],
            codigoProveedor: codigoProveedor && codigoProveedor.trim() !== ""
              ? codigoProveedor.trim()
              : codigo,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Articulo",
            detalle: `${nombre} ${codigo}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    } else{
        axios.patch(
          URL_ARTICULOS_EDIT,
          {
            codigo,
            nombre,
            piezasPorCaja,
            cajasPorTarima: Number(cajasPorTarima) || 0,
            pesoCaja,
            pesoPieza,
            precioKilo,
            precioTienda,
            tamanoCaja,
            costoUSD,
            costoMX,
            venta,
            lineas: selectedLineaEdit,
            subLineas: selectedSubLineaEdit || undefined,
            marcas: selectedMarcaEdit,
            // familias: selectedFamiliaEdit,
            // colecciones: selectedColeccionEdit,
            // composiciones: selectedComposicionEdit,
            proveedores: selectedProveedorEdit,
            empresas: selectedEmpresaEdit,
            ano,
            EAN,
            SKU,
            lista1,
            lista2,
            lista3,
            lista4,
            lista5,
            listaContenedor,
            cbm,
            aranceles,
            vendedores,
            visibleInventario,
            foto: "Si" ,
            codigoSAT,
            codigoUnidad,
            articuloRelacionado: articuloRelacionadoEdit
              ? [articuloRelacionadoEdit]
              : [],
            codigoProveedor: codigoProveedor && codigoProveedor.trim() !== ""
              ? codigoProveedor.trim()
              : codigo,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then(() => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("articulo", idEditArticulo);

        axios
          .post(URL_FILEPOST, formData, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Articulo",
                detalle: `${nombre} ${codigo}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );

            toggleEdit();
            Swal.fire("Good job!", "Actualizado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  }
}
  // Lo que cuesta la mercancía sólo lo ve quien tiene el permiso "Ver Costos
  // de Mercancia": al personal de piso se le esconden estas columnas aquí, en
  // el PDF y en el Excel.
  const COLUMNAS_COSTO = ["costoUSD", "precioKilo", "fobEsperado", "costoMX"];

  const headers = [
    { name: "Activo", field: "activo", sortable: true },
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Pzas Caja", field: "piezasPorCaja", sortable: true },
    { name: "FOB USD", field: "costoUSD", sortable: true },
    { name: "Peso Pieza (kg)", field: "pesoPieza", sortable: true },
    { name: "Precio Kilo USD", field: "precioKilo", sortable: true },
    { name: "FOB Esperado", field: "fobEsperado", sortable: true },
    { name: "Costo MX", field: "costoMX", sortable: true },
    // { name: "Venta", field: "venta", sortable: true },
    { name: "Categoria", field: "linea", sortable: true },
    { name: "SubCategoria", field: "subLinea", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    // { name: "Familia", field: "familia", sortable: true },
    // { name: "Coleccion", field: "coleccion", sortable: true },
    // { name: "Composicion", field: "composicion", sortable: true },
    { name: "Proveedor", field: "proveedor", sortable: true },
    { name: "Empresa", field: "empresa", sortable: true },
    // { name: "Año", field: "ano", sortable: true },
    { name: "Disponible", field: "disponible", sortable: true },
    { name: "Sel", field: "sel", sortable: false },
    { name: "Acciones", field: "acciones", sortable: false },
  ].filter((h) => user.verCostos || !COLUMNAS_COSTO.includes(h.field));

  const commentsData = useMemo(() => {
    // Adjunta el disponible a cada renglón para poder ordenarlo y exportarlo
    let computedComments = comments.map((c) => ({
      ...c,
      disponible: Number(disponiblePorArticulo[String(c._id)] || 0),
    }));

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment._id.toLowerCase().includes(search.toLowerCase()) ||
          comment.codigo.toLowerCase().includes(search.toLowerCase()) ||
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.linea.toLowerCase().includes(search.toLowerCase()) ||
          comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          // comment.familia.toLowerCase().includes(search.toLowerCase()) ||
          // comment.coleccion.toLowerCase().includes(search.toLowerCase()) ||
          // comment.composicion.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.empresa.toLowerCase().includes(search.toLowerCase()) ||
          comment.piezasPorCaja.toString().includes(search) ||
          comment.costoUSD.toString().includes(search) ||
          comment.costoMX.toString().includes(search) ||
          // comment.venta.toString().includes(search) ||
          comment.ano.toString().includes(search)
      );
    }
    if (selectedCodigo) {
      computedComments = computedComments.filter((e) =>
        e._id.includes(selectedCodigo)
      );
    }
    if (selectedNombre) {
      computedComments = computedComments.filter((e) =>
        e._id.includes(selectedNombre)
      );
    }
    if (selectedLinea) {
      computedComments = computedComments.filter((e) =>
        e.idLinea.includes(selectedLinea)
      );
    }
    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.idMarca.includes(selectedMarca)
      );
    }
    // if (selectedFamilia) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idFamilia.includes(selectedFamilia)
    //   );
    // }
    // if (selectedColeccion) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idColeccion.includes(selectedColeccion)
    //   );
    // }
    // if (selectedComposicion) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idComposicion.includes(selectedComposicion)
    //   );
    // }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedor.includes(selectedProveedor)
      );
    }
    if (selectedEmpresa) {
      computedComments = computedComments.filter((e) =>
        e.idEmpresa.includes(selectedEmpresa)
      );
    }
    if (selectedAno) {
      computedComments = computedComments.filter((e) =>
        e.ano.includes(selectedAno)
      );
    }

    if (foto) {
      computedComments = computedComments.filter((e) =>
        e.foto.includes(foto)
      );
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    // Campos que se ordenan como número (el resto va por texto)
    const camposNumericos = [
      "piezasPorCaja",
      "costoUSD",
      "costoMX",
      "disponible",
    ];
    if (sorting.field && !camposNumericos.includes(sorting.field)) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) =>
          reversed *
          String(a[sorting.field] ?? "").localeCompare(String(b[sorting.field] ?? ""))
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      camposNumericos.includes(sorting.field)
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      camposNumericos.includes(sorting.field)
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCodigo,
    selectedNombre,
    selectedLinea,
    selectedSubLinea,
    selectedMarca,
    // selectedFamilia,
    // selectedColeccion,
    // selectedComposicion,
    selectedProveedor,
    selectedEmpresa,
    selectedAno,
    activo,
    foto,
    disponiblePorArticulo
  ]);

  // async function QRGen(
  //   idArt,
  //   codigo,
  //   nombre,
  //   piezasPorCaja,
  //   linea,
  //   marca,
  //   // familia,
  //   // coleccion,
  //   ano,
  //   // composicion,
  //   venta
  // ) {
  //   try {
  //     const res = await axios.get(`${URL_ARTICULOS_PROPORCION}Articulos/${idArt}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     });
  
  //     const allPorporcion = res.data.filter((porcion) => porcion.cantidad !== "0");
  //     const doc = new jsPDF("landscape", "mm", [100, 60], true);
  
  //     const tallas = Array.from(
  //       new Set(allPorporcion.flatMap((porcion) => porcion.tallas.map((talla) => talla.name)))
  //     );
  
  //     const customSizeOrder = [
  //       "EECH", "ECH", "CHICA", "CH", "MEDIANA", "M", "G", "GRANDE", "EXTRA GRANDE", "EG", "2EG", "3EG", "4EG", "5EG", "6EG",
  //       "1X", "2X", "3X", "4X", "5X", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17",
  //       "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33",
  //       "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49",
  //       "50", "5/6", "7/8", "10/12", "14/16"
  //     ];
  //     const sortedTallas = tallas.sort((a, b) => {
  //       return customSizeOrder.indexOf(a) - customSizeOrder.indexOf(b);
  //     });
  
  //     const columns = ["", ...sortedTallas];
  
  //     // Tabla 1: CANTIDADES
  //     const groupedData = {};
  //     allPorporcion.forEach((porcion) => {
  //       const colorName = porcion.colores[0].name;
  //       if (!groupedData[colorName]) {
  //         groupedData[colorName] = {};
  //       }
  //       groupedData[colorName][porcion.tallas[0].name] = porcion.cantidad || 0;
  //     });
  
  //     const rows = Object.keys(groupedData).map((colorName) => {
  //       const rowData = [colorName];
  //       sortedTallas.forEach((talla) => {
  //         rowData.push(groupedData[colorName][talla] || 0);
  //       });
  //       return rowData;
  //     });
  
  //     // Encabezado y tabla de cantidades
  //     doc.setFontSize(8).setFont(undefined, 'bold');
  //     doc.text(`MODELO: ${codigo}`, 5, 5);
  //     doc.setFontSize(6);
  //     doc.text(`Piezas X Caja: ${piezasPorCaja}`, 45, 5);
  //     doc.text(`REF-13 ${venta}`, 70, 5);
  
  //     doc.autoTable({
  //       head: [columns],
  //       body: rows,
  //       startY: 7,
  //       margin: { left: .5, right: .5 },
  //       headStyles: {
  //         fillColor: false,
  //         textColor: [0, 0, 0],
  //         fontStyle: 'bold',
  //         lineWidth: 0,
  //       },
  //       styles: {
  //         fontStyle: 'bold',
  //         fontSize: 5,
  //         cellPadding: .7,
  //         lineWidth: .3,
  //         lineColor: [0, 0, 0],
  //         textColor: [0, 0, 0],
  //       },
  //     });
  
  //     // Tabla 2: EANs
  //     const groupedEanData = {};
  //     allPorporcion.forEach((porcion) => {
  //       const colorName = porcion.colores[0].name;
  //       if (!groupedEanData[colorName]) {
  //         groupedEanData[colorName] = {};
  //       }
  //       groupedEanData[colorName][porcion.tallas[0].name] = porcion.EAN || "";
  //     });
  
  //     const eanRows = Object.keys(groupedEanData).map((colorName) => {
  //       const rowData = [colorName];
  //       sortedTallas.forEach((talla) => {
  //         rowData.push(groupedEanData[colorName][talla] || "");
  //       });
  //       return rowData;
  //     });
  
  //     // Tabla de EANs en la misma página, debajo de la anterior
  //     doc.setFontSize(6);
  //     doc.text(`EAN`, 5, doc.lastAutoTable.finalY + 4);
  
  //     doc.autoTable({
  //       head: [columns],
  //       body: eanRows,
  //       startY: doc.lastAutoTable.finalY + 6,
  //       margin: { left: .5, right: .5 },
  //       headStyles: {
  //         fillColor: false,
  //         textColor: [0, 0, 0],
  //         fontStyle: 'bold',
  //         lineWidth: 0,
  //       },
  //       styles: {
  //         fontStyle: 'bold',
  //         fontSize: 5,
  //         cellPadding: .7,
  //         lineWidth: .3,
  //         lineColor: [0, 0, 0],
  //         textColor: [0, 0, 0],
  //       },
  //     });
  
  //     // Página final: QR
  //     doc.addPage();
  //     const base64 = await qrcode.toDataURL(idArt);
  //     const img3 = new Image();
  //     img3.src = base64;
  //     doc.addImage(img3, "png", 30, 5, 40, 40);
  
  //     // Guardar PDF
  //     abrePDF(doc, `QR.pdf`);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }
  

// function jalaProporcion(
//   idEdit,
//   codigo,
//   nombre,
//   tallas
//   ) {
//   setIdEditArticulo(idEdit);
//   setCodigo(codigo);
//   setNombre(nombre);

//   axios
//   .get(`${URL_ARTICULOS_PROPORCION}Articulos/${idEdit}`, {
//     headers: {
//       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
//     },
//   })
//   .then((res) => {
//     const allProporcion = res.data;
//     let arrayTabla = allProporcion.map((i) => {
//       return {
//         _id: i._id,
//         size: i.tallas[0].name,
//         sizeId: i.tallas[0]._id,
//         color: i.colores[0].name,
//         colorId: i.colores[0]._id,
//         amount: i.cantidad,
//         EAN: i.EAN,
//       };
//     })
//     .filter(function (el) {
//       return el != null;
//     });

//   let dataFinal = Object.values(arrayTabla);
  

// // setArrayTallas(tallas)

// // Setear Colores
// let uniqueColors = {}
// let arrayTablaColores = allProporcion.map((i) => {
//   return {
//     name: i.colores[0].name,
//     id: i.colores[0]._id,
//   };
// })
// .filter(function (el) {
//   if (el && !uniqueColors[el.id]) {
//     uniqueColors[el.id] = true;
//     return true;
//   }
//   return false;
// });

// let dataFinalColores = Object.values(arrayTablaColores);

// setArrayColores(dataFinalColores)

// // Setear Tallas
// let uniqueTallas = {}
// let arrayTablaTallas = allProporcion.map((i) => {
//   return {
//     name: i.tallas[0].name,
//     id: i.tallas[0]._id,
//   };
// })
// .filter(function (el) {
//   if (el && !uniqueTallas[el.id]) {
//     uniqueTallas[el.id] = true;
//     return true;
//   }
//   return false;
// });

// let dataFinalTallas = Object.values(arrayTablaTallas);

// setArrayTallas(dataFinalTallas)

//   function customSort(a, b) {
//     // First, compare colors
//     const colorComparison = a.color.localeCompare(b.color);
  
//     // If colors are the same, compare sizes
//     if (colorComparison === 0) {
//       const sizeOrder = {
//         "CHICA": 0,
//         "MEDIANA": 1,
//         "GRANDE": 2,
//         "EXTRA GRANDE": 3,
//         "2EG": 4,
//         "3EG": 5,
//         "4EG": 6,
//         "5EG": 7,
//         "6EG": 8,
//         "1X": 9,
//         "2X": 10,
//         "3X": 11,
//         "4X": 12,
//         "5X": 13,
//         "6": 14,
//         "7": 15,
//         "8": 16,
//         "9": 17,
//         "10": 18,
//         "11": 19,
//         "12": 20,
//         "13": 21,
//         "14": 22,
//         "15": 23,
//         "16": 24,
//         "17": 25,
//         "18": 26,
//         "19": 27,
//         "20": 28,
//         "21": 29,
//         "22": 30,
//         "23": 31,
//         "24": 32,
//         "25": 33,
//         "26": 34,
//         "27": 35,
//         "28": 36,
//         "29": 37,
//         "30": 38,
//         "31": 39,
//         "32": 40,
//         "33": 41,
//         "34": 42,
//         "35": 43,
//         "36": 44,
//         "37": 45,
//         "38": 46,
//         "39": 47,
//         "40": 48,
//         "41": 49,
//         "42": 50,
//         "43": 51,
//         "44": 52,
//         "45": 53,
//         "46": 54,
//         "47": 55,
//         "48": 56,
//         "49": 57,
//         "50": 58,
//         "5/6": 59,
//         "7/8": 60,
//         "10/12": 61,
//         "14/16": 62,
//       };
      
//       return sizeOrder[a.talla] - sizeOrder[b.talla];
//     }
  
//     return colorComparison;
//   }
  
//   // Sort the array using the custom sort function
//   const sortedData = dataFinal.sort(customSort);

//     setAmounts(sortedData);
//     toggleProporcion();
//   })
//   .catch((err) => console.log(err));


// }


// const handleInputChange = (sizeId, colorId, value, field = "amount") => {
//   const updatedAmounts = [...amounts];
//   const existingEntryIndex = updatedAmounts.findIndex(
//     entry => entry.sizeId === sizeId && entry.colorId === colorId
//   );

//   if (existingEntryIndex !== -1) {
//     updatedAmounts[existingEntryIndex][field] = field === "amount" ? value : value;
//   } else {
//     updatedAmounts.push({
//       sizeId,
//       colorId,
//       amount: field === "amount" ? value : 0,
//       EAN: field === "EAN" ? value : "",
//     });
//   }

//   setAmounts(updatedAmounts);
// };


// const handleInputChangeNew = (sizeId, colorId, value) => {
//   const updatedAmounts = [...inputFields];
//   const existingEntryIndex = updatedAmounts.findIndex(entry => entry.sizeId === sizeId && entry.colorId === colorId);

//   if (existingEntryIndex !== -1) {
//     updatedAmounts[existingEntryIndex].amount = value;
//   } else {
//     updatedAmounts.push({ sizeId, colorId, amount: value });
//   }

//   setInputFields(updatedAmounts);
// };



// function editProporcion(){
//   let total = amounts.length + inputFields.length
//   amounts.map((a) => {
//     axios
//     .patch(`${URL_ARTICULOS_PROPORCION}/${a._id}`,{
//       cantidad: a.amount,
//         EAN: a.EAN
//     }, { 
//         headers: {
//           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
//         },
//       })
//       .then((res) => {
//        total = total - 1
//        if(total == 0){
//          Swal.fire({
//            icon: 'success',
//            title: 'Se actualizo correctamente',
//            showConfirmButton: false,
//            timer: 1500
//          })
//        }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   })

//   inputFields.map((a)=>{
//     if(a.amount>0){
//     axios.post(
//       URL_ARTICULOS_PROPORCION,
//       {
//         articulos: idEditArticulo,
//         cantidad: a.amount,
//         colores: a.colorId,
//         tallas: a.sizeId,
//         EAN: a.EAN
//       },
//       {
//         headers: {
//           Authorization: `Bearer: ${localStorage.getItem(
//             "app_token"
//           )}`,
//         },
//       }
//     ).then(()=>{
//       total = total - 1
//       if(total == 0){
//         axios.post(
//           URL_LOGS,
//           {
//             tipo: "Agregar Color Proporcion",
//             detalle: `${idEditArticulo}`,
//             user: user.id,
//           },
//           {
//             headers: {
//               Authorization: `Bearer: ${localStorage.getItem(
//                 "app_token"
//               )}`,
//             },
//           }
//         );
//         Swal.fire("Good job!", "Creado con exito", `success`);
//         setTimeout(() => {
//           window.location.reload();
//         }, 1000);
//       }
      
//     }).catch((error)=>{
//       console.log(error)
//       setValidaBoton(true)
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Something went wrong!",
//         footer: `${error.response.data}`,
//       });
//     })
//   }else{
//     total = total - 1
//     if(total == 0){
//       axios.post(
//         URL_LOGS,
//         {
//           tipo: "Agregar Color Proporcion",
//           detalle: `${idEditArticulo}`,
//           user: user.id,
//         },
//         {
//           headers: {
//             Authorization: `Bearer: ${localStorage.getItem(
//               "app_token"
//             )}`,
//           },
//         }
//       );
//       Swal.fire("Good job!", "Creado con exito", `success`);
//       setTimeout(() => {
//         window.location.reload();
//       }, 1000);
//     }
//   }
//   })
// }

    // function jalaInfoDuplicar(id){

    //   setidDuplicar(id);

    //   comments.map((a) => {
    //     if(a._id == id){
    //   // setcodigoDuplicar(a.codigo)
    //   setnombreDuplicar(a.nombre)
    //   setdescripcionDuplicar(a.descripcion)
    //   setpesoCajaDuplicar(a.pesoCaja)
    //   setprecioTiendaDuplicar(a.precioTienda)
    //   settamanoCajaDuplicar(a.tamanoCaja)
    //   setpiezasPorCajaDuplicar(a.piezasPorCaja)
    //   setcostoUSDDuplicar(a.costoUSD)
    //   setcostoMXDuplicar(a.costoMX)
    //   setventaDuplicar(a.venta)
    //   setobservacionesDuplicar(a.observaciones)
    //   setcodigoSATDuplicar(a.codigoSAT)
    //   setcodigoUnidadDuplicar(a.codigoUnidad)
    //   setlineasDuplicar(a.idLinea)
    //   setmarcasDuplicar(a.idMarca)
    //   setfamiliasDuplicar(a.idFamilia)
    //   setcoleccionesDuplicar(a.idColeccion)
    //   setcomposicionesDuplicar(a.idComposicion)
    //   setproveedoresDuplicar(a.idProveedor)
    //   setempresasDuplicar(a.idEmpresa)
    //   setanoDuplicar(a.ano)
    //   setEANDuplicar(a.EAN)
    //   setvendedoresDuplicar(a.vendedores)
    //   setvisibleInventarioDuplicar(a.visibleInventario)
    //   setcoloresDuplicar(a.colores)
    //   settallasDuplicar(a.tallas)
    // }})

    // axios
    // .get(`${URL_ARTICULOS_PROPORCION}Articulos/${id}`, {
    //   headers: {
    //     Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //   },
    // })
    // .then((res) => {
    //   const allProporcion = res.data;
    
    //   setProporcionDuplicar(allProporcion);
    // })
    // .catch((err) => console.log(err));


    // }

  //   const saveDuplicar = async (event) => {
  //     setValidaBoton(false);
  
  //     const arrayTallasOfIds = tallasDuplicar.map(talla => talla._id)
  //     const arrayColoresOfIds = coloresDuplicar.map(c => c._id)
      
  // let totalProporcion = proporcionDuplicar.length
  //     try {
  //       await axios
  //         .post(
  //           URL_ARTICULOS,
  //           {
  //             codigo: codigoDuplicar,
  //             nombre: nombreDuplicar,
  //             descripcion: descripcionDuplicar,
  //             pesoCaja: pesoCajaDuplicar,
  //             precioTienda: precioTiendaDuplicar,
  //             tamanoCaja: tamanoCajaDuplicar,
  //             piezasPorCaja: piezasPorCajaDuplicar,
  //             costoUSD: costoUSDDuplicar,
  //             costoMX: costoMXDuplicar,
  //             venta: ventaDuplicar,
  //             observaciones: observacionesDuplicar,
  //             codigoSAT: codigoSATDuplicar,
  //             codigoUnidad: codigoUnidadDuplicar,
  //             lineas: lineasDuplicar,
  //             marcas: marcasDuplicar,
  //             familias: familiasDuplicar,
  //             colecciones: coleccionesDuplicar,
  //             composiciones: composicionesDuplicar,
  //             proveedores: proveedoresDuplicar,
  //             empresas: empresasDuplicar,
  //             ano: anoDuplicar,
  //             EAN: EANDuplicar,
  //             vendedores: vendedoresDuplicar,
  //             visibleInventario: visibleInventarioDuplicar,
  //             colores: arrayColoresOfIds,
  //             tallas: arrayTallasOfIds,
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //             },
  //           }
  //         )
  //         .then((data) => {
  //           axios
  //             .post(
  //               URL_INVENTARIOS,
  //               {
  //                 articulos: data.data._id,
  //                 areas: AREAS_CEDIS,
  //               },
  //               {
  //                 headers: {
  //                   Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //                 },
  //               }
  //             )
  //             .then(() => {
  //               if(proporcionDuplicar.length > 0){
  //               proporcionDuplicar.map((a)=>{
  //                 axios.post(
  //                   URL_ARTICULOS_PROPORCION,
  //                   {
  //                     articulos: data.data._id,
  //                     cantidad: a.cantidad,
  //                     colores: a.colores[0]._id,
  //                     tallas: a.tallas[0]._id
  //                   },
  //                   {
  //                     headers: {
  //                       Authorization: `Bearer: ${localStorage.getItem(
  //                         "app_token"
  //                       )}`,
  //                     },
  //                   }
  //                 ).then(()=>{
  //                   totalProporcion = totalProporcion - 1
  //                   if(totalProporcion === 0){
  //                     axios.post(
  //                       URL_LOGS,
  //                       {
  //                         tipo: "Duplicar Modelo",
  //                         detalle: `${nombreDuplicar} ${codigoDuplicar}`,
  //                         user: user.id,
  //                       },
  //                       {
  //                         headers: {
  //                           Authorization: `Bearer: ${localStorage.getItem(
  //                             "app_token"
  //                           )}`,
  //                         },
  //                       }
  //                     );
  //                     Swal.fire("Good job!", "Creado con exito", `success`);
  //                     setTimeout(() => {
  //                       window.location.reload();
  //                     }, 1000);
  //                   }
                    
  //                 }).catch((error)=>{
  //                   console.log(error)
  //                   setValidaBoton(true)
  //                   Swal.fire({
  //                     icon: "error",
  //                     title: "Oops...",
  //                     text: "Something went wrong!",
  //                     footer: `${error.response.data}`,
  //                   });
  //                 })
  //               })
  //             } else{
  //               axios.post(
  //                 URL_LOGS,
  //                 {
  //                   tipo: "Duplicar modelos",
  //                   detalle: `${nombreDuplicar} ${codigoDuplicar}`,
  //                   user: user.id,
  //                 },
  //                 {
  //                   headers: {
  //                     Authorization: `Bearer: ${localStorage.getItem(
  //                       "app_token"
  //                     )}`,
  //                   },
  //                 }
  //               );
  //               Swal.fire("Good job!", "Creado con exito", `success`);
  //               setTimeout(() => {
  //                 window.location.reload();
  //               }, 1000);
  //             }
  //             })
  //             .catch((error) => {
  //               Swal.fire({
  //                 icon: "error",
  //                 title: "Oops...",
  //                 text: "Something went wrong!",
  //                 footer: `${error.response.data}`,
  //               });
  //               console.log(error);
  //               setValidaBoton(true);
  //             });
  //         })
  //         .catch((error) => {
  //           Swal.fire({
  //             icon: "error",
  //             title: "Oops...",
  //             text: "Something went wrong!",
  //             footer: `${error.response.data}`,
  //           });
  //           console.log(error);
  //           setValidaBoton(true);
  //         });
  //     } catch (error) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Something went wrong!",
  //         footer: `${error.response.data}`,
  //       });
  //       console.log(error);
  //     }
  //   };



    // const addColor = () => {
    //   if(selectedColor == ""){
    //     Swal.fire({
    //       icon: "error",
    //       title: "Oops...",
    //       text: "Selecciona un color!",
    //     });
    //     return
    //   }
    //   let c = "";
    //   let foundColor = colores.find(a => a._id === selectedColor);
      
    //   if (foundColor) {
    //     c = foundColor.name;
    //   }


    //   let add = arrayTallas.map((a) => ({
    //     id: uuidv4(),
    //     colorId: selectedColor,
    //     color: c,
    //     sizeId: a.id,
    //     size: a.name,
    //     EAN: a.EAN,
    //     amount: 0
    //   }));

    //   setInputFields([
    //     ...inputFields, ...add
    //   ]);

    //   let colNew = [...arrayColoresNew, { id: selectedColor, name: c }];
    //   setArrayColoresNew(colNew);
    // };

    // const addTalla = () => {
    //   if(selectedTalla == ""){
    //     Swal.fire({
    //       icon: "error",
    //       title: "Oops...",
    //       text: "Selecciona un Talla!",
    //     });
    //     return
    //   }
    //   let c = "";
    //   let foundTalla = tallas.find(a => a._id === selectedTalla);
      
    //   if (foundTalla) {
    //     c = foundTalla.name;
    //   }


    //   let add = arrayColores.map((a) => ({
    //     id: uuidv4(),
    //     colorId: a.id,
    //     color: a.name,
    //     sizeId: selectedTalla,
    //     size: c,
    //     EAN: a.EAN,
    //     amount: 0
    //   }));

    //   setInputFields([
    //     ...inputFields, ...add
    //   ]);

    //   let colNew = [...arrayTallasNew, { id: selectedTalla, name: c }];
    //   setArrayTallasNew(colNew);
    // };


    function uploadMasiva(){

      filesMasiva.map((a)=>{
        const formData = new FormData();
        formData.append("file", a);
    
        axios
          .post(process.env.REACT_APP_URL_CARGA_MASIVA, formData, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            Swal.fire("Good job!", "Creado con exito", `success`);
           
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response}`,
            });
            console.log(error);
          });
      })
    }

return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card col-12">
          <Row>
            <Col md={6}>
              {user.articulos_create ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/ArticulosCreate"
                >
                  Nuevo Productos
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Productos
                </Button>
              )}
              <Button
                size="sm"
                color="warning"
                onClick={() => setModalCotizador(true)}
              >
                Cotizador
              </Button>
             
              <input
                id="fileVentaHidden"
                name="fileVenta"
                type="file"
                accept=".xlsx,.xls,.csv"
                style={{ display: "none" }}
                onChange={importarVentaExcel}
              />
              
              <input
                id="fileBaseArticulosHidden"
                name="fileBaseArticulos"
                type="file"
                accept=".xlsx,.xls,.csv"
                style={{ display: "none" }}
                onChange={subirBaseArticulos}
              />
              {/* <Button
                size="sm"
                color="info"
                onClick={() => setModalImportPrecios(true)}
              >
                Subir Precios Excel
              </Button> */}
              <Button
                size="sm"
                href="/MenuArticulos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col md={2}>
            {/* <Label>
                Foto
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFilesMasiva(Array.from(e.target.files));
                }}
              />
              <Button
              onClick={uploadMasiva}
                size="sm"
                className="btn btn-success"
                id="botonListado"
              >
                Cargar
              </Button> */}
              </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
              {/* <Button
                  size="sm"
                  className="btn"
                  color="success"
                  onClick={toggleDuplicar}
                >
                  Duplicar
                </Button> */}
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFListaPrecios}
                  title="Lista Precios en PDF"
                >
                  Lista $ PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="success"
                  onClick={ExcelListaPrecios}
                  title="Lista Precios en Excel"
                >
                  Lista $ Excel <i class="far fa-file-excel"></i>
                </Button>
                {/* B3: descargar/subir toda la base de artículos */}
              <Button size="sm" color="success" onClick={descargarBaseArticulos}
                title="Descarga toda la base de artículos a un Excel">
                Bajar BD
              </Button>
              <Button size="sm" color="warning"
                onClick={() => document.getElementById("fileBaseArticulosHidden").click()}
                title="Sube el mismo Excel para actualizar la base (PATCH por _id)">
                Subir BD
              </Button>
                {/* <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button> */}
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel Precios<i class="far fa-file-excel"></i>
                </Button>
                 <Button
                size="sm"
                color="info"
                onClick={() => document.getElementById("fileVentaHidden").click()}
                title="Sube un Excel con columnas 'codigo' y 'venta' para actualizar todos los precios de venta"
              >
                Subir Venta Excel
              </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Modelos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Productos</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          {/* Selección masiva para la lista de precios */}
          <div style={{ marginBottom: 6 }}>
            <Button
              size="sm"
              color="info"
              title="Marca todos los artículos"
              onClick={() =>
                setSeleccionados(
                  comments.reduce((acc, a) => {
                    acc[a._id] = true;
                    return acc;
                  }, {})
                )
              }
            >
              Seleccionar todos
            </Button>{" "}
            <Button
              size="sm"
              color="success"
              title="Deja marcados sólo los que tengan disponible mayor a 0"
              onClick={() =>
                setSeleccionados(
                  comments.reduce((acc, a) => {
                    acc[a._id] =
                      Number(disponiblePorArticulo[String(a._id)] || 0) > 0;
                    return acc;
                  }, {})
                )
              }
            >
              Sólo con disponible
            </Button>{" "}
            <Button size="sm" color="secondary" onClick={() => setSeleccionados({})}>
              Quitar todos
            </Button>{" "}
            <span style={{ marginLeft: 8, fontWeight: 600 }}>
              {Object.values(seleccionados).filter(Boolean).length} seleccionados
            </span>
          </div>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              {/* <td style={{ paddingTop: "0px" }}></td> */}
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={activo}
                  onChange={(e) => {
                    setActivo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                 <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCodigo}
                  onChange={(e) => {
                    setSelectedCodigo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {comments
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.codigo}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedNombre}
                  onChange={(e) => {
                    setSelectedNombre(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {comments
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.nombre}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}></td>
              {/* <td style={{ paddingTop: "0px" }}></td> */}
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedLinea}
                  onChange={(e) => {
                    setSelectedLinea(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {lineas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedSubLinea}
                  onChange={(e) => {
                    setSelectedSubLinea(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {subLineas
                    .filter((s) =>
                      !selectedLinea
                        ? true
                        : String(s.lineas?.[0]?._id || s.lineas?.[0] || "") === String(selectedLinea)
                    )
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => (
                      <option key={a._id} value={a._id}>{a.name}</option>
                    ))}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMarca}
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedFamilia}
                  onChange={(e) => {
                    setSelectedFamilia(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {familias
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td> */}
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedColeccion}
                  onChange={(e) => {
                    setSelectedColeccion(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {colecciones
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td> */}
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedComposicion}
                  onChange={(e) => {
                    setSelectedComposicion(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {composiciones
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td> */}
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedProveedor}
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedEmpresa}
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {empresas
                    .sort((a, b) =>
                      a.name > b.name ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.name}</option>
                      );
                    })}
                </Input>
              </td>
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedAno}
                  onChange={(e) => {
                    setSelectedAno(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {years.map((a) => {
                    return <option value={a}>{a}</option>;
                  })}
                </Input>
              </td> */}
              <td></td>
              <td></td>

              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={foto}
                  onChange={(e) => {
                    setFoto(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Todos</option>
                  <option value="Si">Con Foto</option>
                  <option value="No">Sin Foto</option>
                </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr key={a._id}>
                      <td>{a.activo}</td>
                      <td>{a.codigo}</td>
                      <td>{a.nombre}</td>
                      <td>{a.piezasPorCaja}</td>
                      {user.verCostos && (
                      <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                            a.costoUSD
                          )}{" "}
                      </td>
                      )}
                      <td>{parseFloat(a.pesoPieza || 0) > 0 ? parseFloat(a.pesoPieza).toFixed(3) : "-"}</td>
                      {user.verCostos && (
                      <td>
                        {parseFloat(a.precioKilo || 0) > 0
                          ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioKilo)
                          : "-"}
                      </td>
                      )}
                      {user.verCostos && (
                      <td>
                        {(() => {
                          const fobReal = parseFloat(a.costoUSD) || 0;
                          const fobEsp = parseFloat(a.fobEsperado) || 0;
                          if (fobEsp <= 0) return "-";
                          const diff = fobReal - fobEsp;
                          const pct = fobEsp > 0 ? (diff / fobEsp) * 100 : 0;
                          const ok = Math.abs(pct) < 1;
                          const overcharged = diff > 0 && !ok;
                          const color = ok ? "#28a745" : overcharged ? "#dc3545" : "#17a2b8";
                          return (
                            <span style={{ color, fontWeight: "bold" }} title={`Real: $${fobReal.toFixed(4)} | Dif: ${pct.toFixed(1)}%`}>
                              ${fobEsp.toFixed(4)}
                              {!ok && (
                                <small style={{ marginLeft: 4 }}>
                                  ({pct > 0 ? "+" : ""}{pct.toFixed(1)}%)
                                </small>
                              )}
                            </span>
                          );
                        })()}
                      </td>
                      )}
                      {user.verCostos && (
                      <td>
                        {/* D3: al picarle se abre el desglose del costeo */}
                        <Button
                          color="link"
                          size="sm"
                          style={{
                            padding: 0,
                            textDecoration: "underline",
                            fontWeight: 600,
                            color: Number(a.costoMX) > 0 ? "#0d6efd" : "#dc3545",
                          }}
                          title="Ver cómo se calculó este costo"
                          onClick={() => abrirDesgloseCosto(a)}
                        >
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoMX)}
                        </Button>
                      </td>
                      )}
                      {/* <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.venta)}{" "}
                      </td> */}
                      <td>{a.linea} </td>
                      <td>{a.subLinea} </td>
                      <td>{a.marca} </td>
                      {/* <td>{a.familia} </td>
                      <td>{a.coleccion} </td>
                      <td>{a.composicion} </td> */}
                      <td>{a.proveedor} </td>
                      <td>{a.empresa} </td>
                      <td
                        align="right"
                        style={{
                          fontWeight: 600,
                          color: Number(a.disponible) > 0 ? "#28a745" : "#dc3545",
                        }}
                      >
                        {new Intl.NumberFormat("en-US").format(a.disponible)}
                      </td>
                      <td align="center" style={{ verticalAlign: "middle" }}>
                        <Input
                          type="checkbox"
                          checked={!!seleccionados[a._id]}
                          onChange={(e) => {
                            // React 16 recicla el evento: hay que leer el valor
                            // ANTES de entrar al updater, o e.target llega null.
                            const marcado = e.target.checked;
                            setSeleccionados((prev) => ({
                              ...prev,
                              [a._id]: marcado,
                            }));
                          }}
                          style={{ position: "static", marginLeft: 0 }}
                        />
                      </td>
                      {/* <td>{a.ano} </td> */}
                      <td>
                      <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaFoto(
                                  a._id
                                )
                              }
                            >
                              <i class="fas fa-camera"></i>
                            </Button>
                        {user.articulos_create ? (
                          <div>
                        

                            {/* <Button
                              size="sm"
                              className="btn"
                              color="success"
                              onClick={(e) =>
                                QRGen(
                                  a._id,
                                  a.codigo,
                                  a.nombre,
                                  a.piezasPorCaja,
                                  a.linea,
                                  a.marca,
                                  // a.familia,
                                  // a.coleccion,
                                  a.ano,
                                  // a.composicion,
                                  a.venta
                                )
                              }
                            >
                              <i class="fas fa-qrcode"></i>
                            </Button> */}

                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  a.codigo,
                                  a.nombre,
                                  a.piezasPorCaja,
                                  a.pesoCaja,
                                  a.pesoPieza,
                                  a.precioKilo,
                                  a.precioTienda,
                                  a.tamanoCaja,
                                  a.costoUSD,
                                  a.costoMX,
                                  a.venta,
                                  a.observaciones,
                                  a.codigoSAT,
                                  a.codigoUnidad,
                                  a.idLinea,
                                  a.idSubLinea,
                                  a.idMarca,
                                  // a.idFamilia,
                                  // a.idColeccion,
                                  // a.idComposicion,
                                  a.idProveedor,
                                  a.idEmpresa,
                                  a.ano,
                                  a.EAN,
                                  a.SKU,
                                  a.lista1,
                                  a.lista2,
                                  a.lista3,
                                  a.lista4,
                                  a.lista5,
                                  a.listaContenedor,
                                  a.cbm,
                                  a.aranceles,
                                  a.vendedores,
                                  a.visibleInventario,
                                  a._id,
                                  a.articuloRelacionado,
                                  a.codigoProveedor,
                                  a.cajasPorTarima
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>

                            {/* C21: duplicar artículo — abre el alta con los
                                datos precargados para solo cambiar lo necesario */}
                            <Button
                              color="success"
                              size="sm"
                              title="Duplicar artículo"
                              onClick={() => duplicarArticulo(a._id, a.codigo, a.nombre)}
                            >
                              <i className="far fa-copy"></i>
                            </Button>

                            {/* <Button
                              size="sm"
                              className="btn"
                              color="success"
                              onClick={(e) =>
                                jalaProporcion(
                                  a._id,
                                  a.codigo,
                                  a.nombre,
                                  a.tallas
                                )
                              }
                            >
                              <i class="fas fa-ruler"></i>
                            </Button> */}

                            <Baja
                              idStatus={a._id}
                              is_active={a.activo}
                              URL_BAJA={process.env.REACT_APP_URL_ARTICULOS}
                            />
                          </div>
                        ) : (
                          <div>
                            <Button color="info" id="Editar" size="sm" disabled>
                              <i class="far fa-edit"></i>
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="md" isOpen={modalFoto} toggle={toggleFoto}>
        <ModalHeader toggle={toggleFoto}>
          <h4>
            Ficha Tecnica
          </h4>
        </ModalHeader>
        <ModalBody>
          <small className="text-muted">
            Máximo 5 imágenes. La primera es la principal. Puedes elegir varias
            a la vez y se acomodan en los slots libres.
          </small>
          <Row>
            {[0, 1, 2, 3, 4].map((slot) => {
              const url = fotosArticulo[slot];
              return (
                <Col md={12} key={slot} style={{ marginBottom: 10, borderBottom: "1px solid #eee", paddingBottom: 8 }}>
                  <b>Foto {slot + 1}{slot === 0 ? " (principal)" : ""}</b>
                  {url && (
                    <div style={{ textAlign: "center", margin: "6px 0" }}>
                      <img src={url} alt={`foto-${slot}`} style={{ maxWidth: "100%", maxHeight: 180 }} />
                      <br />
                      <Button size="sm" color="danger" onClick={() => borrarFotoSlot(slot)}>
                        Borrar
                      </Button>
                    </div>
                  )}
                  <Input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={async (e) => {
                      const files = Array.from(e.target.files || []);
                      e.target.value = "";
                      if (!files.length) return;
                      // Sube el primero al slot actual (reemplaza si ya había),
                      // los siguientes se acomodan en los slots libres hacia adelante.
                      const usados = new Set(
                        fotosArticulo
                          .map((u, i) => (u ? i : null))
                          .filter((i) => i !== null && i !== slot)
                      );
                      const libres = [];
                      for (let i = slot; i <= 4 && libres.length < files.length; i++) {
                        if (i === slot || !usados.has(i)) libres.push(i);
                      }
                      for (let k = 0; k < files.length && k < libres.length; k++) {
                        // eslint-disable-next-line no-await-in-loop
                        await subirFotoSlot(libres[k], files[k]);
                      }
                    }}
                  />
                </Col>
              );
            })}
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            Editar Modelo {codigo} / {nombre}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>Codigo</Label>
              <Input
                type="text"
                placeholder="Codigo"
                value={codigo}
                required
                onChange={(e) => {
                  setCodigo(e.target.value);
                  setSKU(e.target.value); // Codigo y SKU son lo mismo
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Codigo Proveedor</Label>
              <Input
                type="text"
                placeholder="(opcional)"
                value={codigoProveedor}
                onChange={(e) => {
                  setCodigoProveedor(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Nombre</Label>
              <Input
                type="text"
                placeholder="Nombre"
                value={nombre}
                required
                onChange={(e) => {
                  setNombre(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Piezas Por Caja</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Piezas Por Caja"
                value={piezasPorCaja}
                required
                onChange={(e) => {
                  setPiezasPorCaja(e.target.value);
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Label>EAN</Label>
              <Input
                type="text"
                placeholder="EAN"
                value={EAN}
                required
                onChange={(e) => {
                  setEAN(e.target.value);
                }}
              />
            </Col>
            {user.verCostos && (
              <>
            <Col md={3}>
              <Label>FOB USD</Label>
              <Input
                type="text"
                placeholder="FOB USD"
                value={costoUSD}
                required
                onChange={(e) => {
                  setCostoUSD(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Costo MX</Label>
              <Input
                type="text"
                placeholder="Costo MX"
                value={costoMX}
                required
                onChange={(e) => {
                  setCostoMX(e.target.value);
                }}
              />
            </Col>
              </>
            )}
             <Col md={3}>
                            <Label>Aranceles</Label>
                            <Input
                              type="text"
                              placeholder="Aranceles"
                              value={aranceles}
                              required
                              onChange={(e) => {
                                setAranceles(e.target.value);
                              }}
                            />
                          </Col>
            {/* <Col md={3}>
              <Label>Venta</Label>
              <Input
                type="text"
                placeholder="Venta"
                value={venta}
                required
                onChange={(e) => {
                  setVenta(e.target.value);
                }}
              />
            </Col> */}

            {/* <Col md={3}>
                <Label>Precio A Tienda</Label>
                <Input
                  type="number"
                  value={precioTienda}
                  required
                  onChange={(e) => {
                    setPrecioTienda(e.target.value);
                  }}
                />
              </Col> */}

          </Row>
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Categoria</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedLineaEdit}
                required
                onChange={(e) => {
                  setSelectedLineaEdit(e.target.value);
                  setSelectedSubLineaEdit("");
                }}
              >
                <option value="0">Selecciona una Categoria</option>
                {lineas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">SubCategoria</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedSubLineaEdit}
                onChange={(e) => setSelectedSubLineaEdit(e.target.value)}
              >
                <option value="">Selecciona una SubCategoria</option>
                {subLineas
                  .filter((s) => !selectedLineaEdit || (s.lineas?.[0]?._id || s.lineas?.[0]) === selectedLineaEdit)
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => (
                    <option key={a._id} value={a._id}>{a.name}</option>
                  ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Marca</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedMarcaEdit}
                required
                onChange={(e) => {
                  setSelectedMarcaEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Marca</option>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
             <Col md={2}>
                              <Label>CBM (m³)</Label>
                              <Input
                                type="number"
                                min="0"
                                step="any"
                                value={cbm}
                                onChange={(e) => setCbm(e.target.value)}
                              />
                            </Col>
            {/* <Col md={3}>
              <Label className="mr-sm-2">Familia</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedFamiliaEdit}
                required
                onChange={(e) => {
                  setSelectedFamiliaEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Familia</option>
                {familias
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Coleccion</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedColeccionEdit}
                required
                onChange={(e) => {
                  setSelectedColeccionEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Coleccion</option>
                {colecciones
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col> 
          </Row>
          <Row> */}
            {/* <Col md={3}>
              <Label>Año</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={ano}
                required
                onChange={(e) => {
                  setAno(e.target.value);
                }}
              >
                <option value="0">Selecciona un Año</option>
                {years.map((a) => {
                  return <option value={a}>{a}</option>;
                })}
              </Input>
            </Col> */}
            {/* SKU sincronizado con Codigo (U1) */}
            {/* <Col md={3}>
              <Label className="mr-sm-2">Composicion</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedComposicionEdit}
                required
                onChange={(e) => {
                  setSelectedComposicionEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Composicion</option>
                {composiciones
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col> */}
            </Row>
            <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Proveedor</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedProveedorEdit}
                required
                onChange={(e) => {
                  setSelectedProveedorEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Proveedor</option>
                {proveedores
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
                <Label>Tamaño Caja</Label>
                <Input
                  type="text"
                  placeholder="Tamaño Caja"
                  value={tamanoCaja}
                  required
                  onChange={(e) => {
                    setTamanoCaja(e.target.value);
                  }}
                />
              </Col>
            <Col md={3}>
                <Label>Peso Caja (kg)</Label>
                <Input
                  type="number"
                  step="any"
                  placeholder="Peso Caja"
                  value={pesoCaja}
                  required
                  onChange={(e) => {
                    setPesoCaja(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Peso Pieza (kg)</Label>
                <Input
                  type="number"
                  step="any"
                  placeholder="Peso por pieza en kg"
                  value={pesoPieza}
                  onChange={(e) => setPesoPieza(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <Label>Precio por Kilo (USD)</Label>
                <Input
                  type="number"
                  step="any"
                  placeholder="USD por kg negociado"
                  value={precioKilo}
                  onChange={(e) => setPrecioKilo(e.target.value)}
                />
                {parseFloat(precioKilo) > 0 && parseFloat(pesoPieza) > 0 && (
                  (() => {
                    const fobEsperado = parseFloat(precioKilo) * parseFloat(pesoPieza);
                    const fobReal = parseFloat(costoUSD) || 0;
                    const diff = fobReal - fobEsperado;
                    const pctDiff = fobEsperado > 0 ? (diff / fobEsperado) * 100 : 0;
                    const ok = Math.abs(pctDiff) < 1;
                    const color = ok ? "#28a745" : diff > 0 ? "#dc3545" : "#17a2b8";
                    return (
                      <small style={{ color, fontWeight: "bold" }}>
                        FOB esperado: ${fobEsperado.toFixed(4)} | Real: ${fobReal.toFixed(4)}
                        {fobReal > 0 && (
                          <> | Dif: {diff >= 0 ? "+" : ""}${diff.toFixed(4)} ({pctDiff.toFixed(1)}%)</>
                        )}
                      </small>
                    );
                  })()
                )}
              </Col>

              <Col md={3}>
                <Label>Visible Vendedores</Label>
                <Input
                  type="select"
                  value={vendedores}
                  required
                  onChange={(e) => {
                    setVendedores(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="No">No</option>
                  <option value="Si">Si</option>
                </Input>
              </Col>

              <Col md={3}>
              <Label className="mr-sm-2">Empresa</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedEmpresaEdit}
                required
                onChange={(e) => {
                  setSelectedEmpresaEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Empresa</option>
                {empresas
                  .sort((a, b) =>
                    a.name > b.name ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>  

              <Col md={3}>
              <Label>Observaciones</Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Codigo SAT</Label>
              <Input
                type="text"
                placeholder="CodigoSAT"
                value={codigoSAT}
                required
                onChange={(e) => {
                  setCodigoSAT(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Codigo Unidad</Label>
              <Input
                type="text"
                placeholder="CodigoUnidad"
                value={codigoUnidad}
                required
                onChange={(e) => {
                  setCodigoUnidad(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Cajas Por Tarima</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Cajas Por Tarima"
                value={cajasPorTarima}
                onChange={(e) => {
                  setCajasPorTarima(e.target.value);
                }}
              />
            </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Visible Inventario</Label>
                <Input
                  type="select"
                  value={visibleInventario}
                  required
                  onChange={(e) => {
                    setVisibleInventario(e.target.value);
                  }}
                >
                  <option value="No">No</option>
                  <option value="Si">Si</option>
                </Input>
              </Col>
              <Col md={9}>
                <Label>Articulo Relacionado</Label>
                <Autocomplete
                  size="small"
                  value={
                    comments.find((a) => a._id === articuloRelacionadoEdit) ||
                    null
                  }
                  onChange={(event, sel) => {
                    setArticuloRelacionadoEdit(sel ? sel._id : "");
                  }}
                  options={comments
                    .filter((a) => a._id !== idEditArticulo)
                    .slice()
                    .sort((a, b) =>
                      (a.codigo || "").localeCompare(b.codigo || "")
                    )}
                  getOptionLabel={(option) =>
                    option && (option.codigo || option.nombre)
                      ? `${option.codigo || ""} ${option.nombre || ""}`
                      : ""
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(option) => (
                    <React.Fragment>
                      {option.codigo} {option.nombre}
                    </React.Fragment>
                  )}
                />
              </Col>
            </Row>
                          <br />
                          <h4>Precios de Venta</h4>
                          <small style={{ color: "#666" }}>
                            Lista1 base · Lista2 −30% · Lista3 −25% · Lista4 −20% · Lista5 −15% (todas se sincronizan).
                          </small>
                          <Row>
                          <Col md={2}>
                              <Label>Lista 1 (base)</Label>
                              <Input type="number" min="0" step="any" value={lista1} required
                                onChange={(e) => {
                                  const v = e.target.value;
                                  setLista1(v);
                                  const n = parseFloat(v);
                                  if (!isNaN(n)) {
                                    setLista2(Number((n * 0.7).toFixed(2)));
                                    setLista3(Number((n * 0.75).toFixed(2)));
                                    setLista4(Number((n * 0.8).toFixed(2)));
                                    setLista5(Number((n * 0.85).toFixed(2)));
                                  } else {
                                    setLista2(0); setLista3(0); setLista4(0); setLista5(0);
                                  }
                                }}
                              />
                            </Col>
                            <Col md={2}>
                              <Label>Lista 2 (−30%)</Label>
                              <Input type="number" min="0" step="any" value={lista2} required
                                onChange={(e) => {
                                  const v = e.target.value;
                                  setLista2(v);
                                  const n = parseFloat(v);
                                  if (!isNaN(n) && n > 0) {
                                    const base = n / 0.7;
                                    setLista1(Number(base.toFixed(2)));
                                    setLista3(Number((base * 0.75).toFixed(2)));
                                    setLista4(Number((base * 0.8).toFixed(2)));
                                    setLista5(Number((base * 0.85).toFixed(2)));
                                  }
                                }}
                              />
                            </Col>
                            <Col md={2}>
                              <Label>Lista 3 (−25%)</Label>
                              <Input type="number" min="0" step="any" value={lista3} required
                                onChange={(e) => {
                                  const v = e.target.value;
                                  setLista3(v);
                                  const n = parseFloat(v);
                                  if (!isNaN(n) && n > 0) {
                                    const base = n / 0.75;
                                    setLista1(Number(base.toFixed(2)));
                                    setLista2(Number((base * 0.7).toFixed(2)));
                                    setLista4(Number((base * 0.8).toFixed(2)));
                                    setLista5(Number((base * 0.85).toFixed(2)));
                                  }
                                }}
                              />
                            </Col>
                            <Col md={2}>
                              <Label>Lista 4 (−20%)</Label>
                              <Input type="number" min="0" step="any" value={lista4} required
                                onChange={(e) => {
                                  const v = e.target.value;
                                  setLista4(v);
                                  const n = parseFloat(v);
                                  if (!isNaN(n) && n > 0) {
                                    const base = n / 0.8;
                                    setLista1(Number(base.toFixed(2)));
                                    setLista2(Number((base * 0.7).toFixed(2)));
                                    setLista3(Number((base * 0.75).toFixed(2)));
                                    setLista5(Number((base * 0.85).toFixed(2)));
                                  }
                                }}
                              />
                            </Col>
                            <Col md={2}>
                              <Label>Lista 5 (−15%)</Label>
                              <Input type="number" min="0" step="any" value={lista5}
                                onChange={(e) => {
                                  const v = e.target.value;
                                  setLista5(v);
                                  const n = parseFloat(v);
                                  if (!isNaN(n) && n > 0) {
                                    const base = n / 0.85;
                                    setLista1(Number(base.toFixed(2)));
                                    setLista2(Number((base * 0.7).toFixed(2)));
                                    setLista3(Number((base * 0.75).toFixed(2)));
                                    setLista4(Number((base * 0.8).toFixed(2)));
                                  }
                                }}
                              />
                            </Col>
                            <Col md={2}>
                              <Label>Lista Contenedor</Label>
                              <Input
                                type="number"
                                min="0"
                                step="any"
                                value={listaContenedor}
                                onChange={(e) => setListaContenedor(e.target.value)}
                              />
                            </Col>
                            
                          </Row>
                          <br />

            <Col md={6}>
              <Label>
                Foto
              </Label>
              <Input
                type="file"
                onChange={(e) => {
                  setFile(e.target.files[0]);
                }}
              />
            </Col>  

        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editArticulos}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>


      {/* <Modal size="lg" isOpen={modalDuplicar} toggle={toggleDuplicar}>
        <ModalHeader toggle={toggleDuplicar}>
        </ModalHeader>
        <ModalBody>
<Row>
      <Col md={6}><Label>Articulo a duplicar </Label>
          <Input
          type="select"
          value={idDuplicar}
          required
          onChange={(e) => {
           jalaInfoDuplicar(e.target.value)
   
          }}
          >
          <option value="0">Selecciona</option>
          {comments
            .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
            .map((a) => {
              return <option value={a._id}>{a.codigo}</option>;
            })}

          </Input>
          </Col>
          </Row>

          <Row>
      <Col md={6}><Label>Codigo Nuevo</Label>
          <Input
          type="text"
          value={codigoDuplicar}
          required
          onChange={(e) => {
           setcodigoDuplicar(e.target.value)
          }}
          />
          </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={saveDuplicar}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal> */}

      {/* V1: Modal subir Excel para actualizar precios */}
      <Modal size="md" isOpen={modalImportPrecios} toggle={toggleImportPrecios}>
        <ModalHeader toggle={toggleImportPrecios}>Actualizar precios desde Excel</ModalHeader>
        <ModalBody>
          <p style={{ fontSize: 12, color: "#666" }}>
            Sube un Excel con columnas <b>codigo</b> y <b>fob</b>. El FOB se promediará con el actual y el costo MX se recalculará con el TC promedio.
          </p>
          <Label>Tipo de Cambio Promedio</Label>
          <Input
            type="number"
            step="0.0001"
            min="0"
            placeholder="Ej. 19.50"
            value={tcPromedio}
            onChange={(e) => setTcPromedio(e.target.value)}
          />
          <br />
          <Label>Archivo Excel</Label>
          <Input
            type="file"
            name="filePrecios"
            accept=".xlsx,.xls"
            onChange={importarPreciosExcel}
          />
          {importPreciosResult.ok > 0 && (
            <p style={{ marginTop: 10, color: "green" }}>
              {importPreciosResult.ok} actualizados.
              {importPreciosResult.noEncontrados.length > 0 && (
                <span style={{ color: "red" }}> No encontrados: {importPreciosResult.noEncontrados.join(", ")}</span>
              )}
            </p>
          )}
        </ModalBody>
      </Modal>

      {/* V2: Modal Cotizador estilo Qualyshop */}
      <Modal size="xxl" isOpen={modalCotizador} toggle={toggleCotizador}>
        <ModalHeader toggle={toggleCotizador}>
          <h4>Cotizador</h4>
        </ModalHeader>
        <ModalBody>
          {(() => {
            const piezasPorCajaCot = numCot(cotizador.piezasPorCaja);
            const cbmCajaCot = numCot(cotizador.cbmCaja);
            const precioFobCot = numCot(cotizador.precioFob);
            const cbmContCot = numCot(cotizador.cbmContenedor);
            const fleteCot = numCot(cotizador.fleteMaritimo);
            const impCot = numCot(cotizador.impuestos);
            const tcCot = numCot(cotizador.tipoCambio);
            const ventaCot = numCot(cotizador.venta);
            const envioCot = numCot(cotizador.envio);
            const comCot = numCot(cotizador.comision);
            const cajasPorCont = cbmCajaCot > 0 ? cbmContCot / cbmCajaCot : 0;
            const piezasPorCont = cajasPorCont * piezasPorCajaCot;
            const totalImp = impCot + fleteCot;
            const costoImpPza = piezasPorCont > 0 ? totalImp / piezasPorCont : 0;
            const costoTotalDlls = costoImpPza + precioFobCot;
            const costoTotalPesos = tcCot * costoTotalDlls;
            const gastos = costoTotalPesos * 1.05;
            const tePagan = ventaCot - envioCot - comCot;
            const utilidad = tePagan - gastos;
            const margen = gastos > 0 ? tePagan / gastos : 0;
            const rojoStyle = { backgroundColor: "#ffcccc" };
            const amaStyle = { backgroundColor: "#fff7a8" };
            return (
              <Table bordered size="sm" responsive>
                <thead>
                  <tr>
                    <th>SKU</th>
                    <th>PIEZAS POR CAJA</th>
                    <th>CBM/CAJA</th>
                    <th>PRECIO FOB</th>
                    <th>CBM CONTENEDOR</th>
                    <th>CAJAS POR CONTENEDOR</th>
                    <th>PIEZAS POR CONTENEDOR</th>
                    <th>FLETE MARITIMO</th>
                    <th>IMPUESTOS</th>
                    <th>TOTAL IMPORTACION</th>
                    <th>COSTO IMPORTACION POR PIEZA</th>
                    <th>COSTO TOTAL PRODUCTO DLLS</th>
                    <th>TIPO DE CAMBIO</th>
                    <th>COSTO TOTAL PRODUCTO PESOS</th>
                    <th>GASTOS</th>
                    <th>VENTA</th>
                    <th>ENVIO</th>
                    <th>COMISION</th>
                    <th>TE PAGAN</th>
                    <th>UTILIDAD</th>
                    <th>MARGEN</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><Input bsSize="sm" name="sku" value={cotizador.sku} onChange={handleChangeCotizador} style={rojoStyle} /></td>
                    <td><Input bsSize="sm" type="number" name="piezasPorCaja" value={cotizador.piezasPorCaja} onChange={handleChangeCotizador} style={rojoStyle} /></td>
                    <td><Input bsSize="sm" type="number" step="0.0001" name="cbmCaja" value={cotizador.cbmCaja} onChange={handleChangeCotizador} style={rojoStyle} /></td>
                    <td><Input bsSize="sm" type="number" step="0.01" name="precioFob" value={cotizador.precioFob} onChange={handleChangeCotizador} style={rojoStyle} /></td>
                    <td><Input bsSize="sm" type="number" step="0.01" name="cbmContenedor" value={cotizador.cbmContenedor} onChange={handleChangeCotizador} style={rojoStyle} /></td>
                    <td><Input bsSize="sm" disabled value={cajasPorCont.toFixed(2)} style={amaStyle} /></td>
                    <td><Input bsSize="sm" disabled value={piezasPorCont.toFixed(2)} style={amaStyle} /></td>
                    <td><Input bsSize="sm" type="number" step="0.01" name="fleteMaritimo" value={cotizador.fleteMaritimo} onChange={handleChangeCotizador} style={rojoStyle} /></td>
                    <td><Input bsSize="sm" type="number" step="0.01" name="impuestos" value={cotizador.impuestos} onChange={handleChangeCotizador} style={rojoStyle} /></td>
                    <td><Input bsSize="sm" disabled value={totalImp.toFixed(2)} style={amaStyle} /></td>
                    <td><Input bsSize="sm" disabled value={costoImpPza.toFixed(4)} style={amaStyle} /></td>
                    <td><Input bsSize="sm" disabled value={costoTotalDlls.toFixed(4)} style={amaStyle} /></td>
                    <td><Input bsSize="sm" type="number" step="0.01" name="tipoCambio" value={cotizador.tipoCambio} onChange={handleChangeCotizador} style={rojoStyle} /></td>
                    <td><Input bsSize="sm" disabled value={costoTotalPesos.toFixed(2)} style={amaStyle} /></td>
                    <td><Input bsSize="sm" disabled value={gastos.toFixed(2)} style={amaStyle} /></td>
                    <td><Input bsSize="sm" type="number" step="0.01" name="venta" value={cotizador.venta} onChange={handleChangeCotizador} style={rojoStyle} /></td>
                    <td><Input bsSize="sm" type="number" step="0.01" name="envio" value={cotizador.envio} onChange={handleChangeCotizador} style={rojoStyle} /></td>
                    <td><Input bsSize="sm" type="number" step="0.01" name="comision" value={cotizador.comision} onChange={handleChangeCotizador} style={rojoStyle} /></td>
                    <td><Input bsSize="sm" disabled value={tePagan.toFixed(2)} style={amaStyle} /></td>
                    <td><Input bsSize="sm" disabled value={utilidad.toFixed(2)} style={amaStyle} /></td>
                    <td><Input bsSize="sm" disabled value={(margen * 100).toFixed(2) + " %"} style={amaStyle} /></td>
                  </tr>
                </tbody>
              </Table>
            );
          })()}
        </ModalBody>
      </Modal>

      {/* D3: desglose de cómo se calculó el costoMX */}
      <Modal size="xl" isOpen={modalDesglose} toggle={() => setModalDesglose(!modalDesglose)}>
        <ModalHeader toggle={() => setModalDesglose(!modalDesglose)}>
          <h4>Cómo se calculó el costo — {desgloseArticulo}</h4>
        </ModalHeader>
        <ModalBody>
          <div style={{ marginBottom: 10 }}>
            <b>Costo MX actual del artículo: </b>
            <span style={{ fontSize: 18, fontWeight: "bold", color: desgloseCostoActual > 0 ? "#28a745" : "#dc3545" }}>
              {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(desgloseCostoActual)}
            </span>
          </div>

          {desgloseLoading ? (
            <div align="center">Cargando…</div>
          ) : desgloseRows.length === 0 ? (
            <div style={{ padding: 12, backgroundColor: "#fff3cd", borderRadius: 4 }}>
              <b>Este artículo nunca se ha costeado.</b>
              <br />
              El costo sólo se calcula cuando se costea un embarque donde venga el
              artículo. Si el costo está en $0, revisa que el embarque
              correspondiente esté <b>recibido y costeado</b> en Compras → Embarques.
            </div>
          ) : (
            desgloseRows.map((d, i) => {
              const money = (n) =>
                new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 4 }).format(Number(n) || 0);
              return (
                <div key={d._id} style={{ marginBottom: 18, border: "1px solid #dee2e6", borderRadius: 4 }}>
                  <div style={{ backgroundColor: i === 0 ? "#d4edda" : "#f1f1f1", padding: 8, fontWeight: "bold" }}>
                    {i === 0 ? "★ Último costeo — " : ""}
                    Embarque #{d.embarque} {d.contenedor ? `· ${d.contenedor}` : ""} · {d.fecha} · {d.tipo}
                  </div>
                  <Table size="sm" borderless style={{ marginBottom: 0 }}>
                    <tbody>
                      <tr><td>Cantidad recibida</td><td align="right">{new Intl.NumberFormat("en-US").format(d.cantidad)}</td><td></td></tr>
                      <tr>
                        <td>FOB unitario (USD)</td>
                        <td align="right">{money(d.costoFOB)}</td>
                        <td>× TC {d.tipoCambio} = <b>{money(d.fobUnitarioPesos)}</b></td>
                      </tr>
                      {d.comisionUSD > 0 && (
                        <tr>
                          <td>Comisión vendedor (USD)</td>
                          <td align="right">{money(d.comisionUSD)}</td>
                          <td>× TC = <b>{money(d.comisionPesos)}</b></td>
                        </tr>
                      )}
                      <tr>
                        <td>Gastos prorrateados</td>
                        <td align="right">{money(d.gastoPorPieza)}</td>
                        <td>
                          {(d.porcentajeFOB * 100).toFixed(2)}% del gasto del embarque
                          {" "}({money(d.gastoTotalArticulo)} entre {new Intl.NumberFormat("en-US").format(d.cantidad)} pzas)
                        </td>
                      </tr>
                      {d.tipo === "Kasher" ? (
                        <>
                          <tr>
                            <td>IGI / arancel ({d.igiPorcentaje}%)</td>
                            <td align="right">{money(d.igi)}</td>
                            <td>sobre el valor declarado</td>
                          </tr>
                          <tr>
                            <td>IVA ({d.ivaPorcentaje}%)</td>
                            <td align="right">{money(d.iva)}</td>
                            <td>sobre declarado + IGI</td>
                          </tr>
                          <tr>
                            <td>Impuestos por pieza</td>
                            <td align="right">{money(d.impuestosUnitarios)}</td>
                            <td>({money(d.impuestos)} entre {new Intl.NumberFormat("en-US").format(d.cantidad)} pzas)</td>
                          </tr>
                        </>
                      ) : (
                        <tr>
                          <td colSpan={3} style={{ fontStyle: "italic", color: "#6c757d" }}>
                            Embarque Taref: no lleva IGI ni IVA en el costeo.
                          </td>
                        </tr>
                      )}
                      <tr style={{ borderTop: "2px solid #333", fontWeight: "bold" }}>
                        <td>= Costo unitario de este embarque</td>
                        <td align="right">{money(d.costoUnitario)}</td>
                        <td>FOB + comisión + gastos + impuestos</td>
                      </tr>
                      {Number(d.costoPromediado) > 0 && Number(d.costoPromediado) !== Number(d.costoUnitario) && (
                        <tr style={{ fontWeight: "bold", color: "#0d6efd" }}>
                          <td>= Costo promediado</td>
                          <td align="right">{money(d.costoPromediado)}</td>
                          <td>promedio con la existencia que ya había en inventario</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              );
            })
          )}
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoArticulos;


